
import PageTitle from "../components/common/pageTitle";
import React, { useState, useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles, Typography } from "@material-ui/core"
import HomeStyles from '../styles/Home.module.css'
import Breadcrumbs from "../components/common/Breadcrumbs";
import Banner from "../components/common/banner";
import CssTextField from '../libs/config/inputConfig';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import axios from 'axios';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import useToken from '../components/auth/useToken';
import { withSnackbar } from "../libs/config/snackbar.config";
import convertISOStringToMonthDay from "../services/convertDate";
import GetAppIcon from '@material-ui/icons/GetApp';
import FormGroup from '@material-ui/core/FormGroup';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import api from '../libs/utils/axiosApiInstance'

import {
    MuiPickersUtilsProvider,
    DatePicker,
    KeyboardDatePicker
} from '@material-ui/pickers';
import OverwriteMomentBE from "../libs/config/OverwriteMomemtBE";

function sleep(delay = 0) {
    return new Promise((resolve) => {
        setTimeout(resolve, delay);
    });
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

const titles = [
    'นาย',
    'นาง',
    'นางสาว',
    'อื่นๆ'
]

const PersonTypes = [
    'บุคคลธรรมดา',
    'นิติบุคคล',
]

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column'
    },
    margin: {
        marginBottom: theme.spacing(3),
    },
    title: {
        fontWeight: 'bold',
        marginBottom: '2rem',
    },
    buttonConfirm: {
        background: '#3364AF',
        fontSize: '1.0rem',
        width: '100%',
        height: '45px',
    },
    buttonUpload: {
        background: '#FBBE66',
        color: '#FFFFFF',
        fontSize: '1.0rem',
        width: '100%',
        height: '52px',
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
    },
    customInput: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: 'auto',
    },

}));

const TypesFile = [
    {
        name: 'สำเนาบัตรประจำตัวประชาชน',
        value: 'IdCardFiles',
    },
    {
        name: 'สำเนาหนังสือจดทะเบียนเป็นนิติบุคคลหรือทะเบียนพาณิชย์',
        value: 'JuristicPersonFiles',
    },
    {
        name: 'สำเนาใบอนุญาตขายเมล็ดพันธุ์ควบคุม (พ.พ.4)',
        value: 'LicenseFiles',
    },
    {
        name: 'แผนผังแสดงที่อยู่และสถานที่ตั้งของสถานที่จำหน่ายเมล็ดพันธุ์',
        value: 'StoreMapFiles',
    },
    {
        name: 'หนังสือมอบอำนาจซึ่งติดอากรแสตมป์ตามกฎหมาย',
        value: 'ProxyFiles',
    },
    {
        name: 'เอกสารอื่นๆ',
        value: 'OtherFiles',
    },
]

const TypesFileExpires = [
    {
        name: 'สำเนาใบอนุญาตตัวแทนจำหน่ายเมล็ดพันธุ์พืช ของกรมข้าว ที่สิ้นอายุ',
        value: 'ExpiredAgentExtFiles',
    },
    {
        name: 'สำเนาบัตรประจำตัวประชาชน',
        value: 'IdCardExtFiles',
    },
    {
        name: 'สำเนาหนังสือจดทะเบียนเป็นนิติบุคคลหรือทะเบียนพาณิชย์',
        value: 'JuristicPersonExtFiles',
    },
    {
        name: 'สำเนาใบอนุญาตรวบรวมเมล็ดพันธุ์ควบคุมเพื่อการค้า',
        value: 'LicenseExtFiles',
    },
    {
        name: 'แผนผังแสดงที่อยู่และสถานที่ตั้งของสถานที่จำหน่ายเมล็ด',
        value: 'StoreMapExtFiles',
    },

    {
        name: 'หนังสือมอบอำนาจ ในกรณีที่ผู้ยื่นคำขอได้รับมอบอำนาจให้ยื่นคำขอต่ออายุแทน',
        value: 'ProxyExtFiles',
    },
    {
        name: 'เอกสารอื่นๆ',
        value: 'OtherExtFiles',
    },



]




function Profile(props) {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const history = useHistory();
    const [isLoading, setLoading] = React.useState(false);
    const [agentsList, setAgentList] = React.useState([]);
    const handleOnLink = useCallback(() => history.push('/confirm-email'), [history]);
    const handleChangeTabs = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeIndex = (index) => {
        setValue(index);
    };
    const { token, setToken } = useToken();

    const [openIssuerProvince, setOpenIssuerProvince] = React.useState(false);
    const [openIssuerDistrict, setOpenIssuerDistrict] = React.useState(false);
    const [expire, CheckExpire] = React.useState(false);


    const [openProvince, setOpenProvince] = React.useState(false);
    const [openDistrict, setOpenDistrict] = React.useState(false);
    const [openSubDistrict, setOpenSubDistrict] = React.useState(false);
    const [openZipcode, setOpenZipcode] = React.useState(false);

    const [openShopProvince, setOpenShopProvince] = React.useState(false);
    const [openShopDistrict, setOpenShopDistrict] = React.useState(false);
    const [openShopSubDistrict, setOpenShopSubDistrict] = React.useState(false);
    const [openShopZipcode, setOpenShopZipcode] = React.useState(false);

    const [openOfficeProvince, setOpenOfficeProvince] = React.useState(false);
    const [openOfficeDistrict, setOpenOfficeDistrict] = React.useState(false);
    const [openOfficeSubDistrict, setOpenOfficeSubDistrict] = React.useState(false);
    const [openOfficeZipcode, setOpenOfficeZipcode] = React.useState(false);
    // const [val, setVal] = useState({
    //     Province: '',
    //     District: '',
    //     SubDistrict: '',
    //     Zipcode: '',
    // })

    const [options, setOptions] = React.useState([]);
    const loadingProvince = openProvince && options.length === 0;
    const loadingDistrict = openDistrict && options.length === 0;
    const loadingSubDistrict = openSubDistrict && options.length === 0;
    const loadingZipcode = openZipcode && options.length === 0;

    const loadingShopProvince = openShopProvince && options.length === 0;
    const loadingShopDistrict = openShopDistrict && options.length === 0;
    const loadingShopSubDistrict = openShopSubDistrict && options.length === 0;
    const loadingShopZipcode = openShopZipcode && options.length === 0;

    const loadingOfficeProvince = openOfficeProvince && options.length === 0;
    const loadingOfficeDistrict = openOfficeDistrict && options.length === 0;
    const loadingOfficeSubDistrict = openOfficeSubDistrict && options.length === 0;
    const loadingOfficeZipcode = openOfficeZipcode && options.length === 0;

    const loadingIssuerProvince = openIssuerProvince && options.length === 0;
    const loadingIssuerDistrict = openIssuerDistrict && options.length === 0;

    let [isLoadingSubmit, setLoadingSubmit] = useState(false);

    const [typeList, setTypeList] = useState([]);
    const [catalogList, setCatalogList] = useState([]);
    const [url, setUrl] = useState('');

    const [loadingDownLoad, setLoadingDownLoad] = useState({
        registerLoading: false,
        agentLoading: false
    });

    let [openPopup, setOpenPopup] = useState()
    const [branchs, setBranchs] = useState([]);
    // const [files, setFiles] = useState([]);
    const FilesUpload = React.useRef(null);

    // const JuristicPersonFiles = React.useRef(null);
    // const LicenseFiles = React.useRef(null);
    // const StoreMapFiles = React.useRef(null);
    // const ProxyFiles = React.useRef(null);
    // const OtherFiles = React.useRef(null);
    // const handleClickUpload = event => {

    //     IdCardFiles.current.click();
    // };
    const selectedAgent = agent => {
        // console.log(agent);
        if (agent) {
            localStorage.setItem('requestNo', agent.RequestNo);
            window.location.reload(false);
        }
    }

    const init = async () => {
        const response = await fetch("/resources/config.json");
        const results = await response.json();
        setUrl(results?.REACT_APP_ADMIN_URL);
    }


    const handleBirthdayChange = (date) => {
        if (date) {
            const birthDay = new Date(date);
            const datenow = new Date()
            const today_year = datenow.getFullYear();
            const birth_year = birthDay.getFullYear();
            const age = today_year - birth_year;
            setInput({
                ...input,
                BirthDate: new Date(date),
                age: age
            });
        }
    };

    const handleIssuerDateChange = (date) => {
        if (date) {
            setInput({
                ...input,
                IssuerDate: new Date(date)

            });
        }
    };

    let [input, setInput] = useState({
        RequestNo: '',
        AgentNumber: '',
        BranchNo: '',
        Fname: '',
        Lname: '',
        Email: '',
        Tel: '',
        Fax: '',
        HouseNumber: '',
        Moo: '',
        NationalityId: '',
        BirthDate: '',
        IssuerDistrict: '',
        IssuerProvince: '',
        PersonType: '',
        IssuerDate: '',
        JuristicPersonType: '',
        JuristicPersonId: '',
        AuthorizedSignatory: '',
        AgentExpireDate: null,
        ContactName: '',
        Alley: '',
        Address: '',
        Province: '',
        BirthDate: '',
        District: '',
        SubDistrict: '',
        Zipcode: '',
        Status: '',
        Title: '',
        ShopHouseNumber: '',
        ShopMoo: '',
        ShopAddress: '',
        ShopProvince: '',
        ShopDistrict: '',
        ShopSubDistrict: '',
        ShopZipcode: '',
        ShopAlley: '',
        ShopTel: '',
        ShopFax: '',

        OfficeAddress: '',
        OfficeAlley: '',
        OfficeDistrict: '',
        OfficeHouseNumber: '',
        OfficeMoo: '',
        OfficeProvince: '',
        OfficeSubDistrict: '',
        OfficeZipcode: '',
        OfficeTel: '',
        OfficeFax: '',

        OtherTitle: '',

        ItemTypeName_1: '',
        ItemCatalogName_1: '',
        ItemSaleAmount_1: null,

        ItemTypeName_2: '',
        ItemCatalogName_2: '',
        ItemSaleAmount_2: null,

        ItemTypeName_3: '',
        ItemCatalogName_3: '',
        ItemSaleAmount_3: null,

        ItemTypeName_4: '',
        ItemCatalogName_4: '',
        ItemSaleAmount_4: null,
        term: false,
        age: '',
        Nationality: '',
        coppyNationalityToOfficeAddress: false,
        coppyShopToOfficeAddress: false,
        typeFileSelected: TypesFile[0].value,

    });

    useEffect(() => {
        const params = new URLSearchParams(history?.location?.search)
        if (params.get('tabIndex')) {
            setValue(+params.get('tabIndex'))
        }


        const fetchType = async () => {
            const response = await api.get(`/dbms/itemtypes`);

            const b = await response.data;
            setTypeList(b.result)
        }

        const fetchCatalog = async () => {
            const response = await api.get(`/dbms/itemcatalogs`);

            const b = await response.data;
            setCatalogList(b.result)
        }

        fetchType();
        fetchCatalog();
        getProfile();
        init()
    }, []);


    useEffect(() => {
        if (input.AgentNumber) {
            const datenow = new Date();
            const _expireDate = new Date(input.AgentExpireDate);
            const yearExpire = _expireDate.getFullYear();

            const addLincenseStart = new Date(yearExpire, 11);
            const addLincenseEnd = new Date(yearExpire, 11, 31, 11, 59, 59);
            if (datenow.getTime() >= addLincenseStart.getTime() && datenow.getTime() <= addLincenseEnd.get()) {
                CheckExpire(true);
            } else {
                CheckExpire(false);
            }


        }
    }, [input]);

    const handleSetIssuerAddress = (value) => {

        if (value) {
            setInput({
                ...input,
                IssuerDistrict: value.DistrictName,
                IssuerProvince: value.ProvinceName,

            });
        }



    };

    const renderInput = (props) => (

        <CssTextField type="text" style={{
            width: '100%'
        }}
            onClick={props.onClick}
            value={props.value}
            onChange={props.onChange}
            className={classes.margin}
            name={props.name}
            id={props.id}
            InputProps={{ disableUnderline: true }}
            required={props.required}
            error={props.error}
            label={props.label}
        />
    );

    const getProfile = async () => {

        const res = await api.get(`/profile/agents/${localStorage.getItem('requestNo')}`, { headers: { "Authorization": `Bearer ${token}` } });
        const profile = res.data.result;
        if (profile) {
            const res2 = await api.get(`/profile/agents`, { headers: { "Authorization": `Bearer ${token}` } });
            const aList = res2.data.result;
            setAgentList(aList);
            const title = titles.find(x => x === profile?.Title);
            const birthDay = new Date(profile.BirthDate);
            const datenow = new Date()
            const today_year = datenow.getFullYear();
            const birth_year = birthDay.getFullYear();
            const age = today_year - birth_year;
            setInput({
                ...profile,
                BirthDate: profile.BirthDate ? new Date(profile.BirthDate) : '',
                IssuerDate: profile.IssuerDate ? new Date(profile.IssuerDate) : '',
                Title: title ? title : 'อื่นๆ',
                OtherTitle: !title ? profile.Title : '',
                age: age
            });




            const _FilesAgent = res.data.result.Files;
            let fixfileUploaded = [];

            for (const c of _FilesAgent) {

                const type = TypesFile.find(x => x.value === c.FileType);

                const extension = c.FileName.split('.')?.pop();
                const pathImg = getPathImage(extension);

                fixfileUploaded.push({
                    UploadFileId: c.UploadFileId,
                    file: {
                        name: c.FileName
                    },
                    typeName: c.FileType,
                    typeShow: type.name,
                    typeFile: extension,
                    pathImg: pathImg,
                    isNew: false
                })


            }

            setFiles(fixfileUploaded);
        }
        console.log(input);
    }




    const handleChangeFile = (event) => {

        const { target } = event;
        const { name } = target;
        const value = target.value;
        if (event.target.files.length > 0) {
            const fileUploaded = event.target.files[0];
            const type = TypesFile.find(x => x.value === input.typeFileSelected);

            const extension = fileUploaded.name.split('.')?.pop();
            const pathImg = getPathImage(extension);

            const fixfileUploaded = {
                UploadFileId: null,
                file: fileUploaded,
                typeName: type.value,
                typeShow: type.name,
                typeFile: extension,
                pathImg: pathImg,
                isNew: true
            }
            const updateFiles = [
                ...files,
                fixfileUploaded,
            ];
            // update the state to the updatedUsers
            setFiles(updateFiles);
        }

    };


    const coppyAddress = e => {
        const { target } = e;
        const { name } = target;
        console.log(name);
        if (name === 'coppyNationalityToShopAddress') {

            if (target.checked) {
                setInput({
                    ...input,
                    ShopHouseNumber: input.HouseNumber,
                    ShopMoo: input.Moo,
                    ShopAlley: input.Alley,
                    ShopAddress: input.Address,
                    ShopProvince: input.Province,
                    ShopSubDistrict: input.SubDistrict,
                    ShopZipcode: input.Zipcode,
                    ShopDistrict: input.District,
                });
            } else {
                setInput({
                    ...input,
                    ShopHouseNumber: '',
                    ShopMoo: '',
                    ShopAlley: '',
                    ShopAddress: '',
                    ShopProvince: '',
                    ShopSubDistrict: '',
                    ShopZipcode: '',
                    ShopDistrict: '',
                });
            }
        }

        if (name === 'coppyNationalityToOfficeAddress') {
            if (target.checked) {
                setInput({
                    ...input,
                    OfficeHouseNumber: input.HouseNumber || '',
                    OfficeMoo: input.Moo || '',
                    OfficeAlley: input.Alley || '',
                    OfficeAddress: input.Address || '',
                    OfficeProvince: input.Province,
                    OfficeSubDistrict: input.SubDistrict,
                    OfficeZipcode: input.Zipcode,
                    OfficeDistrict: input.District,
                    coppyNationalityToOfficeAddress: true,
                    coppyShopToOfficeAddress: false
                });

            } else {
                setInput({
                    ...input,
                    OfficeHouseNumber: '',
                    OfficeMoo: '',
                    OfficeAlley: '',
                    OfficeAddress: '',
                    OfficeProvince: '',
                    OfficeSubDistrict: '',
                    OfficeZipcode: '',
                    OfficeDistrict: '',
                    coppyNationalityToOfficeAddress: false,
                });
            }
        }

        if (name === 'coppyShopToOfficeAddress') {
            if (target.checked) {
                setInput({
                    ...input,
                    OfficeHouseNumber: input.ShopHouseNumber || '',
                    OfficeMoo: input.ShopMoo || '',
                    OfficeAlley: input.ShopAlley || '',
                    OfficeAddress: input.ShopAddress || '',
                    OfficeProvince: input.ShopProvince || '',
                    OfficeSubDistrict: input.ShopSubDistrict || '',
                    OfficeZipcode: input.ShopZipcode || '',
                    OfficeDistrict: input.ShopDistrict || '',
                    coppyShopToOfficeAddress: true,
                    coppyNationalityToOfficeAddress: false

                });

            } else {
                setInput({
                    ...input,
                    OfficeHouseNumber: '',
                    OfficeMoo: '',
                    OfficeAlley: '',
                    OfficeAddress: '',
                    OfficeProvince: '',
                    OfficeSubDistrict: '',
                    OfficeZipcode: '',
                    OfficeDistrict: '',
                    coppyShopToOfficeAddress: false,
                });
            }
        }
    }

    const handleClickUpload = event => {

        FilesUpload.current.click();
    };

    const downloadFileRequest = async () => {
        setLoadingDownLoad({
            ...loadingDownLoad,
            registerLoading: true
        });
        const path = `/agents/${input.RequestNo}/register/pdf`;

        const res = await api.get(path, {

            responseType: 'arraybuffer',
            headers: { "Authorization": `Bearer ${token}` }
        });
        const buffer = res.data;
        const blob = new Blob([buffer], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        setLoadingDownLoad({
            ...loadingDownLoad,
            registerLoading: false
        });
        window.open(url, '_blank');
    }

    const downloadFileAgent = async () => {
        setLoadingDownLoad({
            ...loadingDownLoad,
            agentLoading: true
        });
        const newAgent = encodeURIComponent(input.AgentNumber);
        const path = `/agents/${newAgent}/pdf`;

        const res = await api.get(path, {

            responseType: 'arraybuffer',
            headers: { "Authorization": `Bearer ${token}` }
        });
        const buffer = res.data;
        const blob = new Blob([buffer], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        setLoadingDownLoad({
            ...loadingDownLoad,
            agentLoading: false
        });
        window.open(url, '_blank');
    }



    const [files, setFiles] = useState([]);
    const [fileRemove, setFilesRemove] = useState([]);

    const removeFiles = async (body) => {

        const data = {
            FileIDs: body
        }
        const path = `/remove-files`

        const res = await api.put(path, data, { headers: { "Authorization": `Bearer ${token}` } });
    }





    const getPathImage = (extension) => {
        if (extension === 'png') {
            return 'icons/png.svg';
        }
        else if (extension === 'jpg') {
            return 'icons/jpg.svg';
        }
        else if (extension === 'pdf') {
            return 'icons/pdf.svg';
        }
        else if (extension === 'doc') {
            return 'icons/doc.svg';
        }
        else if (extension === 'txt') {
            return 'icons/txt.svg';
        }
        else if (extension === 'zip') {
            return 'icons/zip.svg';
        }
        else if (extension === 'xls' || extension === 'xlsx') {
            return 'icons/xls.svg';
        }
        else {
            return 'icons/file.svg';
        }

    }











    const register = () => {
        setOpenPopup(true);
    }






    // const handleChangeFile = e => {

    //     const { target } = e;
    //     const { name } = target;
    //     const value = target.value;
    //     setFiles({
    //         ...input,
    //         [name]: value
    //     });

    // }

    const checkExpire = () => {
        console.log(input);
        return true;
    }

    const handleClickAutoComplete = (value) => {

        if (value) {
            setInput({
                ...input,
                Province: value.ProvinceName,
                SubDistrict: value.SubDistrictName,
                Zipcode: value.Zipcode,
                District: value.DistrictName,

            });
        }

    };

    const handleSetShopAddress = (value) => {

        if (value) {
            setInput({
                ...input,
                ShopProvince: value.ProvinceName,
                ShopSubDistrict: value.SubDistrictName,
                ShopZipcode: value.Zipcode,
                ShopDistrict: value.DistrictName,

            });
        }

    };

    const handleSetOfficeAddress = (value) => {

        if (value) {
            setInput({
                ...input,
                OfficeProvince: value.ProvinceName,
                OfficeSubDistrict: value.SubDistrictName,
                OfficeZipcode: value.Zipcode,
                OfficeDistrict: value.DistrictName,

            });
        }



    };


    const handleChange = e => {

        const { target } = e;
        const { name } = target;


        (async () => {

            let params;
            let response;
            let c = [];
            if (name === 'Province' || name === 'ShopProvince' || name === 'OfficeProvince' || name === 'IssuerProvince') {
                params = `?P=${target.value}`
            } else if (name === 'District' || name === 'ShopDistrict' || name === 'OfficeDistrict' || name === 'IssuerDistrict') {
                params = `?D=${target.value}`
            } else if (name === 'SubDistrict' || name === 'ShopSubDistrict' || name === 'OfficeSubDistrict') {
                params = `?SD=${target.value}`
            } else if (name === 'Zipcode' || name === 'ShopZipcode' || name === 'OfficeZipcode') {
                params = `?Z=${target.value}`
            }

            if (name === 'Province' || name === 'IssuerProvince' || name === 'IssuerDistrict' || name === 'District' || name === 'SubDistrict' || name === 'Zipcode' || name === 'ShopProvince' || name === 'ShopDistrict' || name === 'ShopSubDistrict' || name === 'ShopZipcode' || name === 'OfficeProvince' || name === 'OfficeDistrict' || name === 'OfficeSubDistrict' || name === 'OfficeZipcode') {
                if (target.value) {
                    response = await api.get(`/address${params}`);
                } else {
                    response = await api.get(`/address`);
                }
                await sleep(1e3); // For demo purposes.
                const res = await response.data


                c = res.result || [];
            }


            setOptions(c);

        })();



        const value = name === 'term' ? target.checked : target.value;

        setInput({
            ...input,
            [name]: value
        });


    }

    const onSubmit = async e => {

        e.preventDefault()
        setLoadingSubmit(true);
        const body = input;
        const addFiles = files.length > 0 ? files.filter(x => x.isNew) : [];
        const _fileRemove = fileRemove.length > 0 ? fileRemove : [];
        if (_fileRemove.length > 0) {
            await removeFiles(_fileRemove);
        }



        const formData = new FormData();
        if (addFiles.length > 0) {
            for (const c of addFiles) {
                formData.append(c.typeName, c.file);
            }
        }
        if (input.Alley) {
            formData.append('Alley', input.Alley || '');
        }
        formData.append('ContactName', input.ContactName);
        if (input.AgentNumber) {
            formData.append('AgentNumber', input.AgentNumber);
        }

        formData.append('BranchNo', input.BranchNo);
        formData.append('BirthDate', input.BirthDate ? input.BirthDate.toISOString().slice(0, 10) : '');
        formData.append('Email', input.Email || '');
        formData.append('Fname', input.Fname || '');
        formData.append('Lname', input.Lname || '');

        formData.append('IssuerDistrict', input.IssuerDistrict || '');
        formData.append('IssuerProvince', input.IssuerProvince || '');

        formData.append('Fax', input.Fax || '');
        formData.append('NationalityId', input.NationalityId || '');
        formData.append('Title', input.Title === 'อื่นๆ' ? input?.OtherTitle : input.Title);

        formData.append('Moo', input.Moo || '');



        formData.append('Address', input.Address || '');



        formData.append('HouseNumber', input.HouseNumber || '');


        formData.append('Tel', input.Tel);
        formData.append('Province', input.Province || '');
        formData.append('District', input.District || '');
        formData.append('SubDistrict', input.SubDistrict || '');
        formData.append('Zipcode', input.Zipcode || '');
        formData.append('Status', input.Status);


        formData.append('ShopTel', input.ShopTel || '');

        formData.append('ShopFax', input.ShopFax || '');



        formData.append('ShopAlley', input.ShopAlley || '');


        formData.append('ShopMoo', input.ShopMoo || '');


        formData.append('ShopAddress', input.ShopAddress || '');


        formData.append('Nationality', input.Nationality || '');


        formData.append('ShopHouseNumber', input.ShopHouseNumber || '');

        formData.append('ShopProvince', input.ShopProvince || '');
        formData.append('ShopDistrict', input.ShopDistrict || '');
        formData.append('ShopSubDistrict', input.ShopSubDistrict || '');
        formData.append('ShopZipcode', input.ShopZipcode || '');



        formData.append('OfficeAlley', input.OfficeAlley || '');


        formData.append('OfficeMoo', input.OfficeMoo || '');


        formData.append('OfficeAddress', input.OfficeAddress || '');



        formData.append('OfficeHouseNumber', input.OfficeHouseNumber || '');


        formData.append('OfficeTel', input.OfficeTel || '');

        formData.append('OfficeFax', input.OfficeFax || '');

        formData.append('OfficeProvince', input.OfficeProvince || '');
        formData.append('OfficeDistrict', input.OfficeDistrict || '');
        formData.append('OfficeSubDistrict', input.OfficeSubDistrict || '');
        formData.append('OfficeZipcode', input.OfficeZipcode || '');


        formData.append('IssuerDate', input.IssuerDate ? input.IssuerDate.toISOString().slice(0, 10) : '');



        formData.append('JuristicPersonType', input.JuristicPersonType || '');


        formData.append('JuristicPersonId', input.JuristicPersonId || '');



        formData.append('AuthorizedSignatory', input.AuthorizedSignatory || '');

        const res = await api.put(`/profile/agents/${localStorage.getItem('requestNo')}`, formData, { headers: { "Authorization": `Bearer ${token}` } });

        if (res.data.status) {


            props.snackbarShowMessage(`บันทึกข้อมูลสำเร็จ`);
            getProfile();
            setLoadingSubmit(false);
        } else {
            props.snackbarShowMessage(`มีบางอย่างผิดพลาดกรุณาลองใหม่อีกครั้ง`);
            setLoadingSubmit(false);
        }

    }

    return (
        <>





            <Banner>
                <div className="container">

                    <PageTitle title="Profile" header="ข้อมูลของฉัน" />
                    <Breadcrumbs linkName="ข้อมูลของฉัน" />



                    <div className="row w-100">

                        <div className="col-md-12" >
                            <div className={HomeStyles.card} >

                                <div className="row">
                                    <div className="col-lg-3 col-md-12">
                                        <div className="text-center pt-3 pb-3">
                                            <img style={{
                                                width: '70%',

                                            }} src='user.png' alt="confirmemail"></img>
                                        </div>


                                        <div className="text-center">

                                            <ul className="list-group">
                                                {agentsList.map((m) =>
                                                    <li className={HomeStyles.menuList} style={{
                                                        color: input.RequestNo === m.RequestNo ? 'white' : '',
                                                        backgroundColor: input.RequestNo === m.RequestNo ? '#3364AF' : ''
                                                    }} onClick={() => selectedAgent(m)}>({m.AgentNumber ? m.AgentNumber : 'รออนุมัติ'}) {m.ContactName}</li>
                                                )}
                                            </ul>


                                        </div>
                                    </div>


                                    <div className="col-lg-9 col-md-12">

                                        <Tabs style={{
                                            borderBottom: '1px solid #80808029'
                                        }}
                                            value={value}
                                            onChange={handleChangeTabs}
                                            indicatorColor="primary"
                                            textColor="primary"
                                            variant="scrollable"
                                            scrollButtons="auto"
                                            aria-label="scrollable auto tabs example"
                                        >
                                            <Tab label="ข้อมูลของฉัน" {...a11yProps(0)} />

                                            <Tab label="อัพโหลดไฟล์" {...a11yProps(1)} />
                                            <Tab label="ประวัติการทำรายการ" {...a11yProps(2)} />
                                            <Tab label="เปลี่ยนรหัสผ่าน" {...a11yProps(3)} />
                                            {expire &&
                                                <Tab label="ต่ออายุตัวแทน" {...a11yProps(4)} />
                                            }

                                        </Tabs>

                                        <TabPanel value={value} index={0}>
                                            <div className="row mb-3">
                                                <div className="col-6">
                                                    <Typography variant="h6" style={{
                                                        marginBottom: '15px'
                                                    }}>
                                                        ข้อมูลผู้สมัคร

                                                    </Typography>
                                                </div>
                                                <div className="col-6 text-end">
                                                    <Button variant="outlined" disabled={loadingDownLoad.registerLoading} color="primary" onClick={downloadFileRequest}>
                                                        {loadingDownLoad.registerLoading ? <div className="spinner-border text-primary" role="status">
                                                            <span className="sr-only"></span>
                                                        </div> : ' ดาวน์โหลดใบ ตจ1.'}

                                                    </Button>
                                                    {/* {input.AgentNumber &&
                                                        <Button variant="outlined" disabled={loadingDownLoad.agentLoading} color="primary" style={{
                                                            marginLeft: '10px',
                                                            marginRight: '10px'
                                                        }} onClick={downloadFileAgent}>
                                                            {loadingDownLoad.agentLoading ? <div className="spinner-border text-primary" role="status">
                                                                <span className="sr-only"></span>
                                                            </div> : '  ดาวน์โหลดใบ ตจ4.'}

                                                        </Button>
                                                    } */}
                                                </div>



                                            </div>


                                            <form onSubmit={onSubmit}>
                                                <div className="row w-100">
                                                    {input.AgentNumber &&
                                                        <div className="col-12">
                                                            <CssTextField type="text" disabled name="AgentNumber" id="AgentNumber" value={input.AgentNumber} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="เลขที่ตัวแทนจำหน่าย" />
                                                        </div>
                                                    }

                                                    <div className="col-12">


                                                        <CssTextField select className={classes.margin} name="PersonType" id="PersonType" value={input.PersonType} required error={true} onClick={handleChange} InputProps={{ disableUnderline: true }} fullWidth label="ประเภทบุคคล">
                                                            {/* <Select      required error={true} > */}

                                                            {PersonTypes.map((option) => (
                                                                <MenuItem key={option} value={option}>
                                                                    {option}
                                                                </MenuItem>
                                                            ))}

                                                            {/* </Select> */}
                                                        </CssTextField>

                                                    </div>
                                                    <div className="col-6">
                                                        <CssTextField type="text" required={input?.PersonType === 'นิติบุคคล'} error={true} name="JuristicPersonType" id="JuristicPersonType" value={input.JuristicPersonType} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ประเภทนิติบุคคล" />
                                                    </div>

                                                    <div className="col-6">
                                                        <CssTextField type="text" required={input?.PersonType === 'นิติบุคคล'} error={true} name="JuristicPersonId" id="JuristicPersonId" value={input.JuristicPersonId} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="นิติบุคคลเลขที่" />
                                                    </div>
                                                    <div className="col-6">
                                                        <CssTextField type="text" required={input?.PersonType === 'นิติบุคคล'} error={true} name="AuthorizedSignatory" id="AuthorizedSignatory" value={input.AuthorizedSignatory} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ผู้มีอำนาจลงนามแทน" />
                                                    </div>
                                                    <div className="col-6">
                                                        <MuiPickersUtilsProvider utils={OverwriteMomentBE} locale="th" >
                                                            <DatePicker

                                                                name="IssuerDate"
                                                                id="IssuerDate"
                                                                maxDate={new Date()}
                                                                required={input?.PersonType === 'นิติบุคคล'}
                                                                error={true}
                                                                format='DD/MM/YYYY'
                                                                label="วันที่จดทะเบียน"
                                                                onChange={handleIssuerDateChange}
                                                                value={input.IssuerDate}
                                                                TextFieldComponent={renderInput}



                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </div>
                                                    <div className="col-12">
                                                        <CssTextField type="text" value={input.ContactName} required error={true} name="ContactName" id="ContactName" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ชื่อร้านค้า" />
                                                    </div>
                                                    <div className="col-6">


                                                        <CssTextField select className={classes.margin} name="Title" id="Title" value={input.Title} required error={true} onClick={handleChange} InputProps={{ disableUnderline: true }} fullWidth label="คำนำหน้า">
                                                            {/* <Select      required error={true} > */}

                                                            {titles.map((option) => (
                                                                <MenuItem key={option} value={option}>
                                                                    {option}
                                                                </MenuItem>
                                                            ))}

                                                            {/* </Select> */}
                                                        </CssTextField>

                                                    </div>
                                                    <div className="col-6">
                                                        <CssTextField type="text" required error={true} name="OtherTitle" id="Title" onChange={handleChange} required={input.Title === 'อื่นๆ'} disabled={!input.Title || input.Title !== 'อื่นๆ'} value={input.OtherTitle} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="คำนำหน้าอื่นๆ (โปรดระบุ)" />
                                                    </div>

                                                    <div className="col-6">
                                                        <CssTextField type="text" value={input.Fname} required error={true} name="Fname" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ชื่อ" />
                                                    </div>
                                                    <div className="col-6">
                                                        <CssTextField type="text" value={input.Lname} required error={true} name="Lname" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="นามสกุล" />
                                                    </div>

                                                    <div className="col-6">
                                                        <CssTextField type="number"
                                                            onInput={(e) => {
                                                                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 13)
                                                            }}
                                                            required error={true} name="NationalityId" id="NationalityId" disabled value={input.NationalityId} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="บัตรประจำตัวประชาชน" />
                                                    </div>
                                                    <div className="col-6">
                                                        <CssTextField type="text" value={input.Email} disabled required error={true} name="Email" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="อีเมล" />
                                                    </div>
                                                    <div className="col-12">
                                                        <Autocomplete
                                                            id="IssuerDistrict"
                                                            name="IssuerDistrict"
                                                            getOptionSelected={(option, value) => option === value}
                                                            open={openIssuerDistrict}
                                                            onOpen={() => {
                                                                setOpenIssuerDistrict(true);
                                                            }}
                                                            onClose={() => {
                                                                setOpenIssuerDistrict(false);
                                                            }}
                                                            onChange={(e, value) => handleSetIssuerAddress(value)}
                                                            inputValue={input.IssuerDistrict}
                                                            getOptionLabel={(option) => option.DistrictName || ''}
                                                            renderOption={(option) => (
                                                                <Typography className={classes.comboOptions}>
                                                                    จ.{option?.ProvinceName} / อ.{option?.DistrictName}


                                                                </Typography>
                                                            )}
                                                            options={options}

                                                            loading={loadingIssuerDistrict}
                                                            renderInput={(params) =>
                                                                <CssTextField type="text" required error className={classes.margin} id="IssuerDistrict" name="IssuerDistrict" onChange={handleChange}   {...params} InputProps={
                                                                    {
                                                                        ...params.InputProps, disableUnderline: true, endAdornment: (
                                                                            <React.Fragment>
                                                                                {loadingIssuerDistrict ? <CircularProgress color="inherit" size={20} /> : null}
                                                                                {params.InputProps.endAdornment}
                                                                            </React.Fragment>
                                                                        ),
                                                                    }
                                                                } label="ออกให้ ณ อำเภอ/เขต" />}
                                                        />
                                                    </div>

                                                    <div className="col-12">
                                                        <Autocomplete
                                                            id="IssuerProvince"
                                                            name="IssuerProvince"
                                                            getOptionSelected={(option, value) => option === value}
                                                            open={openIssuerProvince}
                                                            onOpen={() => {
                                                                setOpenIssuerProvince(true);
                                                            }}
                                                            onClose={() => {
                                                                setOpenIssuerProvince(false);
                                                            }}
                                                            onChange={(e, value) => handleSetIssuerAddress(value)}
                                                            inputValue={input.IssuerProvince}
                                                            getOptionLabel={(option) => option.ProvinceName || ''}
                                                            renderOption={(option) => (
                                                                <Typography className={classes.comboOptions}>
                                                                    จ.{option?.ProvinceName} / อ.{option?.DistrictName}

                                                                </Typography>
                                                            )}
                                                            options={options}

                                                            loading={loadingIssuerProvince}
                                                            renderInput={(params) =>
                                                                <CssTextField type="text" required error className={classes.margin} id="IssuerProvince" name="IssuerProvince" onChange={handleChange}   {...params} InputProps={
                                                                    {
                                                                        ...params.InputProps, disableUnderline: true, endAdornment: (
                                                                            <React.Fragment>
                                                                                {loadingIssuerProvince ? <CircularProgress color="inherit" size={20} /> : null}
                                                                                {params.InputProps.endAdornment}
                                                                            </React.Fragment>
                                                                        ),
                                                                    }
                                                                } label="จังหวัด" />}
                                                        />
                                                    </div>
                                                    <div className="col-6">
                                                        <CssTextField className={classes.margin} value={input.Tel} required error={true} name="Tel" onChange={handleChange} InputProps={{ disableUnderline: true }} fullWidth label="โทรศัพท์" />
                                                    </div>
                                                    <div className="col-6">
                                                        <CssTextField className={classes.margin} value={input.Fax} InputProps={{ disableUnderline: true }} name="Fax" onChange={handleChange} fullWidth label="โทรสาร" />
                                                    </div>
                                                    <div className="col-6">
                                                        <MuiPickersUtilsProvider utils={OverwriteMomentBE} locale="th">
                                                            <DatePicker style={{
                                                                width: '100%'
                                                            }}

                                                                name="BirthDate"
                                                                id="BirthDate"
                                                                maxDate={new Date()}
                                                                format='DD/MM/YYYY'
                                                                label="วันเกิด"
                                                                required={true}
                                                                error={true}
                                                                onChange={handleBirthdayChange}
                                                                value={input.BirthDate}

                                                                TextFieldComponent={renderInput}



                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </div>
                                                    <div className="col-3">
                                                        <CssTextField className={classes.margin} value={input.age} required error={true} disabled name="age" InputProps={{ disableUnderline: true }} fullWidth label="อายุ" />
                                                    </div>
                                                    <div className="col-3">
                                                        <CssTextField className={classes.margin} required error={true} value={input.Nationality} InputProps={{ disableUnderline: true }} name="Nationality" onChange={handleChange} fullWidth label="สัญชาติ" />
                                                    </div>
                                                </div>

                                                <Typography variant="h6" style={{
                                                    marginBottom: '15px'
                                                }}>
                                                    ที่อยู่ตามบัตรประชาชน
                                                </Typography>

                                                <div className="row">
                                                    <div className="col-12">
                                                        {/* <TextField id="test" key="test" label="Outlined" variant="outlined" /> */}

                                                        <CssTextField type="text" name="HouseNumber" value={input.HouseNumber} onChange={handleChange} className={classes.margin} required error={true} InputProps={{ disableUnderline: true }} fullWidth label="ที่อยู่เลขที่" />
                                                    </div>
                                                    <div className="col-6">
                                                        <CssTextField type="text" name="Moo" value={input.Moo} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="หมู่" />
                                                    </div>
                                                    <div className="col-6">
                                                        <CssTextField type="text" name="Alley" value={input.Alley} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ตรอก/ซอย" />
                                                    </div>
                                                    <div className="col-12">
                                                        <CssTextField type="text" name="Address" value={input.Address} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ถนน" />
                                                    </div>
                                                    <div className="col-12">
                                                        {/* <CssTextField type="text" name="SubDistrict" required error={true} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth  label="ตำบล/แขวง" /> */}

                                                        <Autocomplete
                                                            id="SubDistrict"
                                                            name="SubDistrict"

                                                            open={openSubDistrict}
                                                            onOpen={() => {
                                                                setOpenSubDistrict(true);
                                                            }}
                                                            onClose={() => {
                                                                setOpenSubDistrict(false);
                                                            }}
                                                            onChange={(e, value) => handleClickAutoComplete(value)}
                                                            inputValue={input.SubDistrict}
                                                            getOptionLabel={(option) => option.SubDistrictName || ''}
                                                            renderOption={(option) => (
                                                                <Typography className={classes.comboOptions}>
                                                                    จ.{option?.ProvinceName} / อ.{option?.DistrictName} /
                                                                    ต.{option?.SubDistrictName} / {option?.Zipcode}

                                                                </Typography>
                                                            )}
                                                            options={options}

                                                            loading={loadingSubDistrict}
                                                            renderInput={(params) =>
                                                                <CssTextField type="text" required className={classes.margin} name="SubDistrict" onChange={handleChange}   {...params} InputProps={
                                                                    {
                                                                        ...params.InputProps, disableUnderline: true, endAdornment: (
                                                                            <React.Fragment>
                                                                                {loadingSubDistrict ? <CircularProgress color="inherit" size={20} /> : null}
                                                                                {params.InputProps.endAdornment}
                                                                            </React.Fragment>
                                                                        ),
                                                                    }
                                                                } label="ตำบล/แขวง" />}
                                                        />
                                                    </div>
                                                    <div className="col-12">
                                                        {/* <CssTextField type="text" name="District" required error={true} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth  label="อำเภอ/เขต" /> */}

                                                        <Autocomplete
                                                            id="District"
                                                            name="District"
                                                            inputValue={input.District}
                                                            open={openDistrict}

                                                            onOpen={() => {
                                                                setOpenDistrict(true);
                                                            }}
                                                            onClose={() => {
                                                                setOpenDistrict(false);
                                                            }}

                                                            onChange={(e, value) => handleClickAutoComplete(value)}
                                                            getOptionLabel={(option) => option.DistrictName || ""}
                                                            renderOption={(option) => (
                                                                <Typography className={classes.comboOptions}>
                                                                    จ.{option?.ProvinceName} / อ.{option?.DistrictName} /
                                                                    ต.{option?.SubDistrictName} / {option?.Zipcode}

                                                                </Typography>
                                                            )}
                                                            options={options}
                                                            loading={loadingDistrict}
                                                            renderInput={(params) =>
                                                                <CssTextField type="text" required className={classes.margin} name="District" onChange={handleChange}   {...params} InputProps={
                                                                    {
                                                                        ...params.InputProps, disableUnderline: true, endAdornment: (
                                                                            <React.Fragment>
                                                                                {loadingDistrict ? <CircularProgress color="inherit" size={20} /> : null}
                                                                                {params.InputProps.endAdornment}
                                                                            </React.Fragment>
                                                                        ),
                                                                    }
                                                                } label="อำเภอ/เขต" />}
                                                        />
                                                    </div>

                                                    <div className="col-12">
                                                        <Autocomplete
                                                            id="Province"
                                                            name="Province"

                                                            inputValue={input.Province}
                                                            onChange={(e, value) => handleClickAutoComplete(value)}
                                                            open={openProvince}
                                                            onOpen={() => {
                                                                setOpenProvince(true);
                                                            }}
                                                            onClose={() => {
                                                                setOpenProvince(false);
                                                            }}
                                                            getOptionLabel={(option) => option.ProvinceName || ""}
                                                            renderOption={(option) => (
                                                                <Typography className={classes.comboOptions}>
                                                                    จ.{option?.ProvinceName} / อ.{option?.DistrictName} /
                                                                    ต.{option?.SubDistrictName} / {option?.Zipcode}

                                                                </Typography>
                                                            )}
                                                            options={options}
                                                            loading={loadingProvince}
                                                            renderInput={(params) =>
                                                                <CssTextField type="text" required className={classes.margin} name="Province" onChange={handleChange}   {...params} InputProps={
                                                                    {
                                                                        ...params.InputProps, disableUnderline: true, endAdornment: (
                                                                            <React.Fragment>
                                                                                {loadingProvince ? <CircularProgress color="inherit" size={20} /> : null}
                                                                                {params.InputProps.endAdornment}
                                                                            </React.Fragment>
                                                                        ),
                                                                    }
                                                                } label="จังหวัด" />}
                                                        />
                                                    </div>
                                                    <div className="col-12">
                                                        {/* <CssTextField type="text" name="Zipcode" required error={true} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth  label="ไปรษณีย์" /> */}
                                                        <Autocomplete
                                                            id="Zipcode"
                                                            name="Zipcode"

                                                            inputValue={input.Zipcode ? input.Zipcode.toString() : ''}
                                                            onChange={(e, value) => handleClickAutoComplete(value)}
                                                            open={openZipcode}
                                                            onOpen={() => {
                                                                setOpenZipcode(true);
                                                            }}
                                                            onClose={() => {
                                                                setOpenZipcode(false);
                                                            }}
                                                            getOptionLabel={(option) => option.Zipcode ? option.Zipcode.toString() : ''}
                                                            renderOption={(option) => (
                                                                <Typography className={classes.comboOptions}>
                                                                    จ.{option?.ProvinceName} / อ.{option?.DistrictName} /
                                                                    ต.{option?.SubDistrictName} / {option?.Zipcode}

                                                                </Typography>
                                                            )}
                                                            options={options}
                                                            loading={loadingZipcode}
                                                            renderInput={(params) =>
                                                                <CssTextField type="text" required className={classes.margin} name="Zipcode" onChange={handleChange}   {...params} InputProps={
                                                                    {
                                                                        ...params.InputProps, disableUnderline: true, endAdornment: (
                                                                            <React.Fragment>
                                                                                {loadingZipcode ? <CircularProgress color="inherit" size={20} /> : null}
                                                                                {params.InputProps.endAdornment}
                                                                            </React.Fragment>
                                                                        ),
                                                                    }
                                                                } label="ไปรษณีย์" />}
                                                        />

                                                    </div>

                                                </div>

                                                <FormGroup row style={{
                                                    display: 'flex',
                                                    alignItems: 'self-start'
                                                }}>
                                                    <Typography variant="h6" style={{
                                                        marginBottom: '15px',
                                                        marginRight: '15px'
                                                    }}>
                                                        สถานที่จำหน่าย
                                                    </Typography>
                                                    <FormControlLabel style={{

                                                    }}
                                                        control={
                                                            <Checkbox
                                                                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                                                checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                                name="coppyNationalityToShopAddress"
                                                                onChange={coppyAddress}
                                                                value={false}
                                                            />
                                                        }
                                                        label={<>
                                                            <div style={{
                                                                fontSize: '0.9rem',
                                                                color: 'red'
                                                            }}>
                                                                <span>ที่อยู่ตามบัตรประชาชน </span>
                                                            </div>

                                                        </>}
                                                    />

                                                </FormGroup>

                                                <div className="row">
                                                    <div className="col-6">
                                                        <CssTextField className={classes.margin} value={input.ShopTel} required error={true} name="ShopTel" id="ShopTel" onChange={handleChange} InputProps={{ disableUnderline: true }} fullWidth label="โทรศัพท์" />
                                                    </div>
                                                    <div className="col-6">
                                                        <CssTextField className={classes.margin} value={input.ShopFax} InputProps={{ disableUnderline: true }} name="ShopFax" id="ShopFax" onChange={handleChange} fullWidth label="โทรสาร" />
                                                    </div>

                                                    <div className="col-6">
                                                        {/* <TextField id="test" key="test" label="Outlined" variant="outlined" /> */}

                                                        <CssTextField type="text" name="ShopHouseNumber" id="ShopHouseNumber" value={input.ShopHouseNumber || ''} onChange={handleChange} className={classes.margin} required error={true} InputProps={{ disableUnderline: true }} fullWidth label="ที่อยู่เลขที่" />
                                                    </div>
                                                    <div className="col-6">
                                                        <CssTextField type="text" name="ShopMoo" id="ShopMoo" value={input.ShopMoo || ''} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="หมู่" />
                                                    </div>
                                                    <div className="col-6">
                                                        <CssTextField type="text" name="ShopAlley" id="ShopAlley" value={input.ShopAlley || ''} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ตรอก/ซอย" />
                                                    </div>
                                                    <div className="col-6">
                                                        <CssTextField type="text" name="ShopAddress" id="ShopAddress" value={input.ShopAddress || ''} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ถนน" />
                                                    </div>
                                                    <div className="col-12">
                                                        {/* <CssTextField type="text" name="SubDistrict" required error={true} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth  label="ตำบล/แขวง" /> */}

                                                        <Autocomplete
                                                            id="ShopSubDistrict"
                                                            name="ShopSubDistrict"

                                                            open={openShopSubDistrict}
                                                            onOpen={() => {
                                                                setOpenShopSubDistrict(true);
                                                            }}
                                                            onClose={() => {
                                                                setOpenShopSubDistrict(false);
                                                            }}
                                                            onChange={(e, value) => handleSetShopAddress(value)}
                                                            inputValue={input.ShopSubDistrict}
                                                            getOptionLabel={(option) => option.SubDistrictName || ''}
                                                            renderOption={(option) => (
                                                                <Typography className={classes.comboOptions}>
                                                                    จ.{option?.ProvinceName} / อ.{option?.DistrictName} /
                                                                    ต.{option?.SubDistrictName} / {option?.Zipcode}

                                                                </Typography>
                                                            )}
                                                            options={options}

                                                            loading={loadingShopSubDistrict}
                                                            renderInput={(params) =>
                                                                <CssTextField type="text" required className={classes.margin} id="ShopSubDistrict" name="ShopSubDistrict" onChange={handleChange}   {...params} InputProps={
                                                                    {
                                                                        ...params.InputProps, disableUnderline: true, endAdornment: (
                                                                            <React.Fragment>
                                                                                {loadingShopSubDistrict ? <CircularProgress color="inherit" size={20} /> : null}
                                                                                {params.InputProps.endAdornment}
                                                                            </React.Fragment>
                                                                        ),
                                                                    }
                                                                } label="ตำบล/แขวง" />}
                                                        />
                                                    </div>
                                                    <div className="col-12">
                                                        {/* <CssTextField type="text" name="District" required error={true} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth  label="อำเภอ/เขต" /> */}

                                                        <Autocomplete
                                                            id="ShopDistrict"
                                                            name="ShopDistrict"
                                                            inputValue={input.ShopDistrict}
                                                            open={openShopDistrict}

                                                            onOpen={() => {
                                                                setOpenShopDistrict(true);
                                                            }}
                                                            onClose={() => {
                                                                setOpenShopDistrict(false);
                                                            }}

                                                            onChange={(e, value) => handleSetShopAddress(value)}
                                                            getOptionLabel={(option) => option.DistrictName || ""}
                                                            renderOption={(option) => (
                                                                <Typography className={classes.comboOptions}>
                                                                    จ.{option?.ProvinceName} / อ.{option?.DistrictName} /
                                                                    ต.{option?.SubDistrictName} / {option?.Zipcode}

                                                                </Typography>
                                                            )}
                                                            options={options}
                                                            loading={loadingShopDistrict}
                                                            renderInput={(params) =>
                                                                <CssTextField type="text" required className={classes.margin} id="ShopDistrict" name="ShopDistrict" onChange={handleChange}   {...params} InputProps={
                                                                    {
                                                                        ...params.InputProps, disableUnderline: true, endAdornment: (
                                                                            <React.Fragment>
                                                                                {loadingShopDistrict ? <CircularProgress color="inherit" size={20} /> : null}
                                                                                {params.InputProps.endAdornment}
                                                                            </React.Fragment>
                                                                        ),
                                                                    }
                                                                } label="อำเภอ/เขต" />}
                                                        />
                                                    </div>
                                                    {/* <div className="col-12">
                                

                                            <Autocomplete
                                                id="combo-box-demo"
                                                options={top100Films}
                                                getOptionLabel={(option) => option.title}
                        
                                                renderInput={(params) => <CssTextField  {...params} name="Province" required error={true} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth  label="จังหวัด" />}
                                            />
                                        </div> */}
                                                    <div className="col-12">
                                                        <Autocomplete
                                                            id="ShopProvince"
                                                            name="ShopProvince"

                                                            inputValue={input.ShopProvince}
                                                            onChange={(e, value) => handleSetShopAddress(value)}
                                                            open={openShopProvince}
                                                            onOpen={() => {
                                                                setOpenShopProvince(true);
                                                            }}
                                                            onClose={() => {
                                                                setOpenShopProvince(false);
                                                            }}
                                                            getOptionLabel={(option) => option.ProvinceName || ""}
                                                            renderOption={(option) => (
                                                                <Typography className={classes.comboOptions}>
                                                                    จ.{option?.ProvinceName} / อ.{option?.DistrictName} /
                                                                    ต.{option?.SubDistrictName} / {option?.Zipcode}

                                                                </Typography>
                                                            )}
                                                            options={options}
                                                            loading={loadingShopProvince}
                                                            renderInput={(params) =>
                                                                <CssTextField type="text" id="ShopProvince" required className={classes.margin} name="ShopProvince" onChange={handleChange}   {...params} InputProps={
                                                                    {
                                                                        ...params.InputProps, disableUnderline: true, endAdornment: (
                                                                            <React.Fragment>
                                                                                {loadingShopProvince ? <CircularProgress color="inherit" size={20} /> : null}
                                                                                {params.InputProps.endAdornment}
                                                                            </React.Fragment>
                                                                        ),
                                                                    }
                                                                } label="จังหวัด" />}
                                                        />
                                                    </div>
                                                    <div className="col-12">
                                                        {/* <CssTextField type="text" name="Zipcode" required error={true} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth  label="ไปรษณีย์" /> */}
                                                        <Autocomplete
                                                            id="ShopZipcode"
                                                            name="ShopZipcode"

                                                            inputValue={input.ShopZipcode ? input.ShopZipcode.toString() : ''}
                                                            onChange={(e, value) => handleSetShopAddress(value)}
                                                            open={openShopZipcode}
                                                            onOpen={() => {
                                                                setOpenShopZipcode(true);
                                                            }}
                                                            onClose={() => {
                                                                setOpenShopZipcode(false);
                                                            }}
                                                            getOptionLabel={(option) => option.Zipcode ? option.Zipcode.toString() : ''}
                                                            renderOption={(option) => (
                                                                <Typography className={classes.comboOptions}>
                                                                    จ.{option?.ProvinceName} / อ.{option?.DistrictName} /
                                                                    ต.{option?.SubDistrictName} / {option?.Zipcode}

                                                                </Typography>
                                                            )}
                                                            options={options}
                                                            loading={loadingShopZipcode}
                                                            renderInput={(params) =>
                                                                <CssTextField type="text " id="ShopZipcode" required className={classes.margin} name="ShopZipcode" onChange={handleChange}   {...params} InputProps={
                                                                    {
                                                                        ...params.InputProps, disableUnderline: true, endAdornment: (
                                                                            <React.Fragment>
                                                                                {loadingShopZipcode ? <CircularProgress color="inherit" size={20} /> : null}
                                                                                {params.InputProps.endAdornment}
                                                                            </React.Fragment>
                                                                        ),
                                                                    }
                                                                } label="ไปรษณีย์" />}
                                                        />

                                                    </div>

                                                </div>

                                                <FormGroup row style={{
                                                    display: 'flex',
                                                    alignItems: 'self-start',
                                                    marginBottom: '15px',
                                                }}>
                                                    <Typography variant="h6" style={{

                                                        marginRight: '15px'
                                                    }}>
                                                        ที่อยู่สำนักงาน
                                                    </Typography>
                                                    <FormControlLabel style={{

                                                    }}
                                                        checked={input.coppyNationalityToOfficeAddress}
                                                        control={
                                                            <Checkbox
                                                                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                                                checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                                name="coppyNationalityToOfficeAddress"

                                                                onChange={coppyAddress}
                                                            />
                                                        }
                                                        label={<>
                                                            <div style={{
                                                                fontSize: '0.9rem',
                                                                color: 'red'
                                                            }}>
                                                                <span>ที่อยู่ตามบัตรประชาชน </span>
                                                            </div>

                                                        </>}


                                                    />

                                                    <FormControlLabel style={{

                                                    }}
                                                        checked={input.coppyShopToOfficeAddress}
                                                        control={
                                                            <Checkbox
                                                                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                                                checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                                name="coppyShopToOfficeAddress"

                                                                onChange={coppyAddress}
                                                            />
                                                        }
                                                        label={<>
                                                            <div style={{
                                                                fontSize: '0.9rem',
                                                                color: 'red'
                                                            }}>
                                                                <span>ที่อยู่ตามสถานที่จำหน่าย </span>
                                                            </div>

                                                        </>}


                                                    />

                                                </FormGroup>

                                                <div className="row">
                                                    <div className="col-6">
                                                        <CssTextField className={classes.margin} required error={true} value={input.OfficeTel} name="OfficeTel" id="OfficeTel" onChange={handleChange} InputProps={{ disableUnderline: true }} fullWidth label="โทรศัพท์" />
                                                    </div>
                                                    <div className="col-6">
                                                        <CssTextField className={classes.margin} InputProps={{ disableUnderline: true }} value={input.OfficeFax} name="OfficeFax" id="OfficeFax" onChange={handleChange} fullWidth label="โทรสาร" />
                                                    </div>
                                                    <div className="col-6">
                                                        {/* <TextField id="test" key="test" label="Outlined" variant="outlined" /> */}

                                                        <CssTextField type="text" name="OfficeHouseNumber" value={input.OfficeHouseNumber || ''} id="OfficeHouseNumber" onChange={handleChange} className={classes.margin} required error={true} InputProps={{ disableUnderline: true }} fullWidth label="ที่อยู่เลขที่" />
                                                    </div>
                                                    <div className="col-6">
                                                        <CssTextField type="text" name="OfficeMoo" id="OfficeMoo" value={input.OfficeMoo || ''} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="หมู่" />
                                                    </div>
                                                    <div className="col-6">
                                                        <CssTextField type="text" name="OfficeAlley" id="OfficeAlley" value={input.OfficeAlley || ''} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ตรอก/ซอย" />
                                                    </div>
                                                    <div className="col-6">
                                                        <CssTextField type="text" name="OfficeAddress" id="OfficeAddress" value={input.OfficeAddress || ''} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ถนน" />
                                                    </div>
                                                    <div className="col-12">
                                                        {/* <CssTextField type="text" name="SubDistrict" required error={true} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth  label="ตำบล/แขวง" /> */}

                                                        <Autocomplete
                                                            id="OfficeSubDistrict"
                                                            name="OfficeSubDistrict"

                                                            open={openOfficeSubDistrict}
                                                            onOpen={() => {
                                                                setOpenOfficeSubDistrict(true);
                                                            }}
                                                            onClose={() => {
                                                                setOpenOfficeSubDistrict(false);
                                                            }}
                                                            onChange={(e, value) => handleSetOfficeAddress(value)}
                                                            inputValue={input.OfficeSubDistrict}
                                                            getOptionLabel={(option) => option.SubDistrictName || ''}
                                                            renderOption={(option) => (
                                                                <Typography className={classes.comboOptions}>
                                                                    จ.{option?.ProvinceName} / อ.{option?.DistrictName} /
                                                                    ต.{option?.SubDistrictName} / {option?.Zipcode}

                                                                </Typography>
                                                            )}
                                                            options={options}

                                                            loading={loadingOfficeSubDistrict}
                                                            renderInput={(params) =>
                                                                <CssTextField type="text" required className={classes.margin} id="OfficeSubDistrict" name="OfficeSubDistrict" onChange={handleChange}   {...params} InputProps={
                                                                    {
                                                                        ...params.InputProps, disableUnderline: true, endAdornment: (
                                                                            <React.Fragment>
                                                                                {loadingOfficeSubDistrict ? <CircularProgress color="inherit" size={20} /> : null}
                                                                                {params.InputProps.endAdornment}
                                                                            </React.Fragment>
                                                                        ),
                                                                    }
                                                                } label="ตำบล/แขวง" />}
                                                        />
                                                    </div>
                                                    <div className="col-12">
                                                        {/* <CssTextField type="text" name="District" required error={true} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth  label="อำเภอ/เขต" /> */}

                                                        <Autocomplete
                                                            id="OfficeDistrict"
                                                            name="OfficeDistrict"
                                                            inputValue={input.OfficeDistrict}
                                                            open={openOfficeDistrict}

                                                            onOpen={() => {
                                                                setOpenOfficeDistrict(true);
                                                            }}
                                                            onClose={() => {
                                                                setOpenOfficeDistrict(false);
                                                            }}

                                                            onChange={(e, value) => handleSetOfficeAddress(value)}
                                                            getOptionLabel={(option) => option.DistrictName || ""}
                                                            renderOption={(option) => (
                                                                <Typography className={classes.comboOptions}>
                                                                    จ.{option?.ProvinceName} / อ.{option?.DistrictName} /
                                                                    ต.{option?.SubDistrictName} / {option?.Zipcode}

                                                                </Typography>
                                                            )}
                                                            options={options}
                                                            loading={loadingOfficeDistrict}
                                                            renderInput={(params) =>
                                                                <CssTextField type="text" required className={classes.margin} id="OfficeDistrict" name="OfficeDistrict" onChange={handleChange}   {...params} InputProps={
                                                                    {
                                                                        ...params.InputProps, disableUnderline: true, endAdornment: (
                                                                            <React.Fragment>
                                                                                {loadingOfficeDistrict ? <CircularProgress color="inherit" size={20} /> : null}
                                                                                {params.InputProps.endAdornment}
                                                                            </React.Fragment>
                                                                        ),
                                                                    }
                                                                } label="อำเภอ/เขต" />}
                                                        />
                                                    </div>
                                                    {/* <div className="col-12">
                                

                                            <Autocomplete
                                                id="combo-box-demo"
                                                options={top100Films}
                                                getOptionLabel={(option) => option.title}
                        
                                                renderInput={(params) => <CssTextField  {...params} name="Province" required error={true} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth  label="จังหวัด" />}
                                            />
                                        </div> */}
                                                    <div className="col-12">
                                                        <Autocomplete
                                                            id="OfficeProvince"
                                                            name="OfficeProvince"

                                                            inputValue={input.OfficeProvince}
                                                            onChange={(e, value) => handleSetOfficeAddress(value)}
                                                            open={openOfficeProvince}
                                                            onOpen={() => {
                                                                setOpenOfficeProvince(true);
                                                            }}
                                                            onClose={() => {
                                                                setOpenOfficeProvince(false);
                                                            }}
                                                            getOptionLabel={(option) => option.ProvinceName || ""}
                                                            renderOption={(option) => (
                                                                <Typography className={classes.comboOptions}>
                                                                    จ.{option?.ProvinceName} / อ.{option?.DistrictName} /
                                                                    ต.{option?.SubDistrictName} / {option?.Zipcode}

                                                                </Typography>
                                                            )}
                                                            options={options}
                                                            loading={loadingOfficeProvince}
                                                            renderInput={(params) =>
                                                                <CssTextField type="text" id="OfficeProvince" required className={classes.margin} name="OfficeProvince" onChange={handleChange}   {...params} InputProps={
                                                                    {
                                                                        ...params.InputProps, disableUnderline: true, endAdornment: (
                                                                            <React.Fragment>
                                                                                {loadingOfficeProvince ? <CircularProgress color="inherit" size={20} /> : null}
                                                                                {params.InputProps.endAdornment}
                                                                            </React.Fragment>
                                                                        ),
                                                                    }
                                                                } label="จังหวัด" />}
                                                        />
                                                    </div>
                                                    <div className="col-12">
                                                        {/* <CssTextField type="text" name="Zipcode" required error={true} onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth  label="ไปรษณีย์" /> */}
                                                        <Autocomplete
                                                            id="OfficeZipcode"
                                                            name="OfficeZipcode"

                                                            inputValue={input.OfficeZipcode ? input.OfficeZipcode.toString() : ''}
                                                            onChange={(e, value) => handleSetOfficeAddress(value)}
                                                            open={openOfficeZipcode}
                                                            onOpen={() => {
                                                                setOpenOfficeZipcode(true);
                                                            }}
                                                            onClose={() => {
                                                                setOpenOfficeZipcode(false);
                                                            }}
                                                            getOptionLabel={(option) => option.Zipcode ? option.Zipcode.toString() : ''}
                                                            renderOption={(option) => (
                                                                <Typography className={classes.comboOptions}>
                                                                    จ.{option?.ProvinceName} / อ.{option?.DistrictName} /
                                                                    ต.{option?.SubDistrictName} / {option?.Zipcode}

                                                                </Typography>
                                                            )}
                                                            options={options}
                                                            loading={loadingOfficeZipcode}
                                                            renderInput={(params) =>
                                                                <CssTextField type="text " id="OfficeZipcode" required className={classes.margin} name="OfficeZipcode" onChange={handleChange}   {...params} InputProps={
                                                                    {
                                                                        ...params.InputProps, disableUnderline: true, endAdornment: (
                                                                            <React.Fragment>
                                                                                {loadingOfficeZipcode ? <CircularProgress color="inherit" size={20} /> : null}
                                                                                {params.InputProps.endAdornment}
                                                                            </React.Fragment>
                                                                        ),
                                                                    }
                                                                } label="ไปรษณีย์" />}
                                                        />

                                                    </div>

                                                </div>

                                                <hr style={{
                                                    color: 'gray'
                                                }}>

                                                </hr>

                                                <Typography variant="h6" style={{
                                                    marginBottom: '15px'
                                                }}>
                                                    ชนิดพืช/พันธุ์  ที่ประสงค์จะขอเป็นตัวแทนจำหน่ายเมล็ดพันธุ์พืช  เบื้องต้น
                                                </Typography>
                                                <div className="row">
                                                    <div className="col-12">
                                                        <table className="table table-bordered">
                                                            <thead>
                                                                <tr style={{
                                                                    background: '#4472c4',
                                                                    color: 'white'
                                                                }}>
                                                                    <th scope="col" className="text-center">ชนิดพืช</th>
                                                                    {/* <th scope="col" className="text-center">หลัก (ตัน)</th> */}
                                                                    <th scope="col" className="text-center">พันธุ์</th>
                                                                    <th scope="col" className="text-center">ปริมาณการขาย (ตัน/ปี)</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>
                                                                        <select className="form-select" name="ItemTypeName_1" onChange={handleChange} value={input?.ItemTypeName_1} aria-label="Default select example">
                                                                            <option value=''>-</option>
                                                                            {typeList.map((option, i) => (
                                                                                <option key={i} value={option.TypeName}> {option.TypeName}</option>
                                                                            ))}

                                                                        </select>
                                                                    </td>
                                                                    <td>
                                                                        <select className="form-select" name="ItemCatalogName_1" onChange={handleChange} value={input?.ItemCatalogName_1} aria-label="Default select example">
                                                                            <option value=''>-</option>
                                                                            {catalogList.map((option, i) => (
                                                                                <option key={i} value={option.CatalogName}> {option.CatalogName}</option>
                                                                            ))}

                                                                        </select>
                                                                    </td>
                                                                    <td>
                                                                        <input type="number" name="ItemSaleAmount_1" onChange={handleChange} value={input?.ItemSaleAmount_1} className="form-control" ></input>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        <select className="form-select" name="ItemTypeName_2" onChange={handleChange} value={input?.ItemTypeName_2} aria-label="Default select example">
                                                                            <option value=''>-</option>
                                                                            {typeList.map((option, i) => (
                                                                                <option key={i} value={option.TypeName}> {option.TypeName}</option>
                                                                            ))}

                                                                        </select>
                                                                    </td>
                                                                    <td>
                                                                        <select className="form-select" name="ItemCatalogName_2" onChange={handleChange} value={input?.ItemCatalogName_2} aria-label="Default select example">
                                                                            <option value=''>-</option>
                                                                            {catalogList.map((option, i) => (
                                                                                <option key={i} value={option.CatalogName}> {option.CatalogName}</option>
                                                                            ))}

                                                                        </select>
                                                                    </td>
                                                                    <td>
                                                                        <input type="number" className="form-control" name="ItemSaleAmount_2" value={input?.ItemSaleAmount_2} onChange={handleChange} ></input>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        <select className="form-select" name="ItemTypeName_3" onChange={handleChange} value={input?.ItemTypeName_3} aria-label="Default select example">
                                                                            <option value=''>-</option>
                                                                            {typeList.map((option, i) => (
                                                                                <option key={i} value={option.TypeName}> {option.TypeName}</option>
                                                                            ))}

                                                                        </select>
                                                                    </td>
                                                                    <td>
                                                                        <select className="form-select" name="ItemCatalogName_3" onChange={handleChange} value={input?.ItemCatalogName_3} aria-label="Default select example">
                                                                            <option value=''>-</option>
                                                                            {catalogList.map((option, i) => (
                                                                                <option key={option} value={option.CatalogName}> {option.CatalogName}</option>
                                                                            ))}

                                                                        </select>
                                                                    </td>
                                                                    <td>
                                                                        <input type="number" className="form-control" name="ItemSaleAmount_3" value={input?.ItemSaleAmount_3} onChange={handleChange} ></input>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        <select className="form-select" name="ItemTypeName_4" value={input?.ItemTypeName_4} onChange={handleChange} aria-label="Default select example">
                                                                            <option value=''>-</option>
                                                                            {typeList.map((option, i) => (
                                                                                <option key={i} value={option.TypeName}> {option.TypeName}</option>
                                                                            ))}

                                                                        </select>
                                                                    </td>
                                                                    <td>
                                                                        <select className="form-select" name="ItemCatalogName_4" value={input?.ItemCatalogName_4} onChange={handleChange} aria-label="Default select example">
                                                                            <option value=''>-</option>
                                                                            {catalogList.map((option, i) => (
                                                                                <option key={i} value={option.CatalogName}> {option.CatalogName}</option>
                                                                            ))}

                                                                        </select>
                                                                    </td>
                                                                    <td>
                                                                        <input type="number" name="ItemSaleAmount_4" value={input?.ItemSaleAmount_4} onChange={handleChange} className="form-control" ></input>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>





                                                    </div>
                                                </div>




                                                <Button variant="contained" type="submit" className={classes.buttonConfirm} color="primary"
                                                >{isLoadingSubmit ? <div className="spinner-border text-light" role="status">
                                                    <span className="sr-only"></span>
                                                </div> : 'บันทึก'}</Button>

                                            </form>
                                        </TabPanel>


                                        <TabPanel value={value} index={1}>
                                            <Attachment props={props} />

                                        </TabPanel>

                                        <TabPanel value={value} index={2}>
                                            <History props={props} />
                                        </TabPanel>

                                        <TabPanel value={value} index={3}>
                                            <ChangePassword props={props} />
                                        </TabPanel>


                                        <TabPanel value={value} index={4}>
                                            <AddLicenTabs props={props} />
                                        </TabPanel>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

            </Banner>







        </>
    )

}



const AddLicenTabs = (props) => {

    const classes = useStyles();
    const [files, setFiles] = useState([]);
    const { token, setToken } = useToken();
    const [openProvince, setOpenProvince] = React.useState(false);
    const [openDistrict, setOpenDistrict] = React.useState(false);
    const [openSubDistrict, setOpenSubDistrict] = React.useState(false);
    const [openZipcode, setOpenZipcode] = React.useState(false);
    const [options, setOptions] = React.useState([]);
    const [isLoadingTab, setLoadingTab] = React.useState(false);
    const loadingProvince = openProvince && options.length === 0;
    const loadingDistrict = openDistrict && options.length === 0;
    const loadingSubDistrict = openSubDistrict && options.length === 0;
    const loadingZipcode = openZipcode && options.length === 0;
    let [isLoadingSubmit, setLoadingSubmit] = useState(false);
    const [fileRemove, setFilesRemove] = useState([]);
    let [isLoading, setLoading] = useState(false);
    const ExpiredAgentExtFiles = React.useRef(null);
    const IdCardExtFiles = React.useRef(null);
    const ProxyExtFiles = React.useRef(null);
    const JuristicPersonExtFiles = React.useRef(null);
    const StoreMapExtFiles = React.useRef(null);
    const LicenseExtFiles = React.useRef(null);
    const OtherExtFiles = React.useRef(null);

    const [loadingDownLoad, setLoadingDownLoad] = useState({
        extentsionLoading: false,
    });


    const handleClickUploadExpiredAgentExtFiles = event => {

        ExpiredAgentExtFiles.current.click();
    };

    const handleClickUploadIdCardExtFiles = event => {

        IdCardExtFiles.current.click();
    };

    const handleClickUploadProxyExtFiles = event => {

        ProxyExtFiles.current.click();
    };

    const handleClickUploadJuristicPersonExtFiles = event => {

        JuristicPersonExtFiles.current.click();
    };

    const handleClickUploadStoreMapExtFiles = event => {

        StoreMapExtFiles.current.click();
    };


    const handleClickUploadLicenseExtFiles = event => {

        LicenseExtFiles.current.click();
    };

    const handleClickUploadOtherExtFiles = event => {

        OtherExtFiles.current.click();
    };



    let [input, setInput] = useState({
        BranchNo: '',
        AgentNumber: '',
        Fname: '',
        Lname: '',
        Email: '',
        Tel: '',
        Fax: '',
        HouseNumber: '',
        Moo: '',
        NationalityId: '',
        Alley: '',
        Address: '',
        Province: '',
        District: '',
        SubDistrict: '',
        Zipcode: '',
        term: false
    });



    useEffect(() => {


        getProfile();

    }, []);

    const getProfile = async () => {
        setLoadingTab(true);
        const res = await api.get(`/profile/agents/${localStorage.getItem('requestNo')}`, { headers: { "Authorization": `Bearer ${token}` } });
        const profile = res.data.result;

        if (profile) {
            const birthDay = new Date(profile.BirthDate);
            const datenow = new Date()
            const today_year = datenow.getFullYear();
            const birth_year = birthDay.getFullYear();
            const age = today_year - birth_year;
            setInput({
                ...input,
                ...profile,
                Fname: `${profile.Title} ${profile.Fname} ${profile.Lname}`,
                BirthDate: profile.BirthDate ? new Date(profile.BirthDate).toISOString().slice(0, 10) : '',
                IssuerDate: profile.IssuerDate ? new Date(profile.IssuerDate).toISOString().slice(0, 10) : '',
                age: age
            });

            const _FilesAgent = res.data.result.ExtentionFiles;
            let fixfileUploaded = [];

            for (const c of _FilesAgent) {

                const type = TypesFileExpires.find(x => x.value === c.FileType);

                const extension = c.FileName.split('.')?.pop();
                const pathImg = getPathImage(extension);
                fixfileUploaded.push({
                    UploadFileId: c.UploadFileId,
                    file: {
                        name: c.FileName
                    },
                    typeName: c.FileType,
                    typeShow: type.name,
                    typeFile: extension,
                    pathImg: pathImg,
                    isNew: false
                })


            }

            setFiles(fixfileUploaded);
        }

        setLoadingTab(false);
    }

    const handleChangeFile = (event) => {

        const { target } = event;
        const { name } = target;
        const value = target.value;
        if (event.target.files.length > 0) {
            const fileUploaded = event.target.files[0];
            const type = TypesFileExpires.find(x => x.value === name);
            const extension = fileUploaded.name.split('.')?.pop();
            const pathImg = getPathImage(extension);
            const fixfileUploaded = {
                UploadFileId: null,
                file: fileUploaded,
                typeName: name,
                typeShow: type.name,
                typeFile: extension,
                pathImg: pathImg,
                isNew: true
            }
            const updateFiles = [
                ...files,
                fixfileUploaded,
            ];
            // update the state to the updatedUsers
            setFiles(updateFiles);
        }

    };



    const getPathImage = (extension) => {
        if (extension === 'png') {
            return 'icons/png.svg';
        }
        else if (extension === 'jpg') {
            return 'icons/jpg.svg';
        }
        else if (extension === 'pdf') {
            return 'icons/pdf.svg';
        }
        else if (extension === 'doc') {
            return 'icons/doc.svg';
        }
        else if (extension === 'txt') {
            return 'icons/txt.svg';
        }
        else if (extension === 'zip') {
            return 'icons/zip.svg';
        }
        else if (extension === 'xls' || extension === 'xlsx') {
            return 'icons/xls.svg';
        }
        else {
            return 'icons/file.svg';
        }

    }

    const handleClickAutoComplete = (value) => {

        if (value) {
            setInput({
                ...input,
                Province: value.ProvinceName,
                SubDistrict: value.SubDistrictName,
                Zipcode: value.Zipcode,
                District: value.DistrictName,

            });
        }

    };


    const downloadFileAgent = async () => {
        setLoadingDownLoad({
            ...loadingDownLoad,
            extentsionLoading: true
        });
        const newAgent = encodeURIComponent(input.AgentNumber);
        const path = `/agents/${newAgent}/extention/pdf`;

        const res = await api.get(path, {

            responseType: 'arraybuffer',
            headers: { "Authorization": `Bearer ${token}` }
        });
        const buffer = res.data;
        const blob = new Blob([buffer], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        setLoadingDownLoad({
            ...loadingDownLoad,
            extentsionLoading: false
        });
        window.open(url, '_blank');
    }

    const handleChange = e => {

        const { target } = e;
        const { name } = target;


        (async () => {

            let params;
            let response;
            let c = [];
            if (name === 'Province') {
                params = `?P=${target.value}`
            } else if (name === 'District') {
                params = `?D=${target.value}`
            } else if (name === 'SubDistrict') {
                params = `?SD=${target.value}`
            } else if (name === 'Zipcode') {
                params = `?Z=${target.value}`
            }

            if (name === 'Province' || name === 'District' || name === 'SubDistrict' || name === 'Zipcode') {
                if (target.value) {
                    response = await api.get(`/address${params}`);
                } else {
                    response = await api.get(`/address`);
                }
                await sleep(1e3); // For demo purposes.
                const res = await response.data


                c = res.result || [];
            }


            setOptions(c);

        })();



        const value = name === 'term' ? target.checked : target.value;

        setInput({
            ...input,
            [name]: value
        });


    }

    const removeFiles = async (body) => {

        const data = {
            FileIDs: body
        }
        const path = `/remove-files`

        const res = await api.put(path, data, { headers: { "Authorization": `Bearer ${token}` } });
    }

    const handleRemove = (file) => {
        if (file.UploadFileId) {
            let _fileRemoves = fileRemove;
            _fileRemoves.push(file.UploadFileId);
            setFilesRemove(_fileRemoves)
        }

        const newFiles = files.filter((files) => files !== file);

        setFiles(newFiles);

    };

    const onSubmit = async e => {

        e.preventDefault()
        const IdCardFiles = files.filter(x => x.typeName === 'IdCardExtFiles');
        const JuristicPersonFiles = files.filter(x => x.typeName === 'JuristicPersonExtFiles');
        const LicenseFiles = files.filter(x => x.typeName === 'LicenseExtFiles');
        const StoreMapFiles = files.filter(x => x.typeName === 'StoreMapExtFiles');
        const ExpiredAgentExtFiles = files.filter(x => x.typeName === 'ExpiredAgentExtFiles');

        if (files.length === 0 || IdCardFiles.length === 0 || JuristicPersonFiles.length === 0 || LicenseFiles.length === 0 || StoreMapFiles.length === 0 || ExpiredAgentExtFiles.length === 0) {

            return props.props.snackbarShowMessage(`กรุณาอัพโหลดเอกสารที่จำเป็นในการต่ออายุตัวแทนให้ครบ`, 'error');
        }
        if (!input?.term) {
            return props.props.snackbarShowMessage(`กรุณายอมรับเงื่อนไขข้อตกลงในการต่ออายุตัวแทน`, 'error');
        }


        setLoadingSubmit(true);
        const body = input;
        const addFiles = files.length > 0 ? files.filter(x => x.isNew) : [];
        const _fileRemove = fileRemove.length > 0 ? fileRemove : [];
        if (_fileRemove.length > 0) {
            await removeFiles(_fileRemove);
        }



        const formData = new FormData();
        // formData.append('ApproveExtention', false);
        if (addFiles.length > 0) {
            for (const c of addFiles) {
                formData.append(c.typeName, c.file);
            }
        }

        const res = await api.post(`/profile/agents/extention/${localStorage.getItem('requestNo')}`, formData, { headers: { "Authorization": `Bearer ${token}` } });

        if (res.data.status) {


            props.props.snackbarShowMessage(`ส่งคำร้องขอต่อใบอนุญาตตัวแทนสำเร็จ กรุณารอเจ้าหน้าที่ตรวจสอบข้อมุล`);
            getProfile();
            setLoadingSubmit(false);
        } else {
            props.props.snackbarShowMessage(`มีบางอย่างผิดพลาดกรุณาลองใหม่อีกครั้ง`, 'error');
            setLoadingSubmit(false);
        }
        setLoadingSubmit(false);
    }


    if (isLoadingTab)
        return (
            <>
                <CircularProgress size={100} />
            </>
        )

    else

        return (
            <>



                <div className="row mb-3">
                    <div className="col-6">
                        <Typography variant="h6" style={{
                            marginBottom: '15px'
                        }}>
                            ข้อมูลตัวแทนจำหน่าย

                        </Typography>
                    </div>
                    <div className="col-6 text-end">
                        {input.AgentNumber &&
                            <Button variant="outlined" disabled={loadingDownLoad.extentsionLoading} color="primary" style={{
                                marginLeft: '10px',
                                marginRight: '10px'
                            }} onClick={downloadFileAgent}>
                                {loadingDownLoad.extentsionLoading ? <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only"></span>
                                </div> : '  ดาวน์โหลดใบ ตจ2.'}

                            </Button>
                        }
                    </div>



                </div>



                <form onSubmit={onSubmit}>
                    <div className="row w-100">

                        <div className="col-6">
                            <CssTextField type="text" value={input.AgentNumber} disabled name="AgentNumber" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="เลขที่ตัวแทนจำหน่าย" />
                        </div>
                        <div className="col-6">
                            <CssTextField type="text" value={input.PersonType} disabled name="PersonType" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ประเภทบุคคล" />
                        </div>
                        <div className="col-6">
                            <CssTextField type="text" value={input.JuristicPersonType} disabled name="JuristicPersonType" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ประเภทนิติบุคคล" />
                        </div>
                        <div className="col-6">
                            <CssTextField type="text" value={input.JuristicPersonId} disabled name="JuristicPersonId" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="นิติบุคคลเลขที่" />
                        </div>
                        <div className="col-6">
                            <CssTextField type="text" value={input.AuthorizedSignatory} disabled name="AuthorizedSignatory" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ผู้มีอำนาจลงนามแทน" />
                        </div>
                        <div className="col-6">
                            <CssTextField type="text" value={input.AuthorizedSignatory} disabled name="AuthorizedSignatory" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="วันที่จดทะเบียน" />
                        </div>
                        <div className="col-12">
                            <CssTextField type="text" value={input.ContactName} disabled name="ContactName" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ชื่อร้าน" />
                        </div>

                        <div className="col-6">
                            <CssTextField type="text" value={input.Fname} disabled name="Fname" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ผู้ดำเนินกิจการ" />
                        </div>

                        <div className="col-6">
                            <CssTextField type="text" value={input.NationalityId} disabled name="NationalityId" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="บัตรประจำตัวประชาชน" />
                        </div>
                        <div className="col-6">
                            <CssTextField type="text" value={input.Email} disabled name="Email" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="อีเมล" />
                        </div>



                        <div className="col-6">
                            <CssTextField className={classes.margin} value={input.Tel} disabled name="Tel" onChange={handleChange} InputProps={{ disableUnderline: true }} fullWidth label="หมายเลขโทรศัพท์" />
                        </div>

                        <div className="col-12">
                            <CssTextField type="text" value={input.IssuerDistrict} disabled name="IssuerDistrict" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ออกให้ ณ อำเภอ/เขต" />
                        </div>
                        <div className="col-12">
                            <CssTextField type="text" value={input.IssuerProvince} disabled name="IssuerProvince" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="จังหวัด" />
                        </div>

                        <div className="col-6">
                            <CssTextField className={classes.margin} value={input.BirthDate} disabled name="BirthDate" onChange={handleChange} InputProps={{ disableUnderline: true }} fullWidth label="วันเกิด" />
                        </div>
                        <div className="col-3">
                            <CssTextField className={classes.margin} value={input.age} disabled name="age" onChange={handleChange} InputProps={{ disableUnderline: true }} fullWidth label="อายุ" />
                        </div>
                        <div className="col-3">
                            <CssTextField className={classes.margin} disabled value={input.Nationality} InputProps={{ disableUnderline: true }} name="Nationality" onChange={handleChange} fullWidth label="สัญชาติ" />
                        </div>
                        <div className="col-6">
                            <CssTextField className={classes.margin} value={input.Fax} disabled name="Fax" onChange={handleChange} InputProps={{ disableUnderline: true }} fullWidth label="โทรสาร" />
                        </div>


                        {/* <div className="col-6">
                                                        <CssTextField className={classes.margin} value={input.Fax} InputProps={{ disableUnderline: true }} fullWidth  label="โทรสาร" />
                                                    </div> */}
                    </div>

                    <Typography variant="h6" style={{
                        marginBottom: '15px'
                    }}>
                        สถานที่จำหน่าย
                    </Typography>

                    <div className="row">
                        <div className="col-6">
                            {/* <TextField id="test" key="test" label="Outlined" variant="outlined" /> */}

                            <CssTextField type="text" name="ShopTel" value={input.ShopTel || ''} disabled onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ที่อยู่เลขที่" />
                        </div>
                        <div className="col-6">
                            {/* <TextField id="test" key="test" label="Outlined" variant="outlined" /> */}

                            <CssTextField type="text" name="ShopFax" value={input.ShopHouseNumber || ''} disabled onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ที่อยู่เลขที่" />
                        </div>
                        <div className="col-6">
                            {/* <TextField id="test" key="test" label="Outlined" variant="outlined" /> */}

                            <CssTextField type="text" name="ShopHouseNumber" value={input.ShopHouseNumber || ''} disabled onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ที่อยู่เลขที่" />
                        </div>
                        <div className="col-6">
                            <CssTextField type="text" name="ShopAddress" value={input.ShopAddress || ''} disabled onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ถนน" />
                        </div>
                        <div className="col-6">
                            <CssTextField type="text" name="ShopMoo" value={input.ShopMoo || ''} disabled onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="หมู่" />
                        </div>
                        <div className="col-6">
                            <CssTextField type="text" name="ShopAlley" value={input.ShopAlley || ''} disabled onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ตรอก/ซอย" />
                        </div>

                        <div className="col-12">
                            <CssTextField type="text" name="ShopSubDistrict" value={input.ShopSubDistrict || ''} disabled onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ตำบล/แขวง" />


                        </div>
                        <div className="col-12">
                            <CssTextField type="text" name="ShopDistrict" value={input.ShopDistrict || ''} disabled onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="อำเภอ/เขต" />


                        </div>

                        <div className="col-12">
                            <CssTextField type="text" name="ShopProvince" value={input.ShopProvince || ''} disabled onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="อำเภอ/เขต" />
                        </div>
                        <div className="col-12">

                            <CssTextField type="text" name="ShopZipcode" value={input.ShopZipcode || ''} disabled onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="อำเภอ/เขต" />

                        </div>

                        <Typography variant="h6" style={{
                            marginBottom: '15px'
                        }}>
                            สถานที่จัดส่ง
                        </Typography>

                        <div className="col-6">
                            {/* <TextField id="test" key="test" label="Outlined" variant="outlined" /> */}

                            <CssTextField type="text" name="OfficeTel" value={input.OfficeTel || ''} disabled onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="โทรศัพท์" />
                        </div>
                        <div className="col-6">
                            {/* <TextField id="test" key="test" label="Outlined" variant="outlined" /> */}

                            <CssTextField type="text" name="OfficeFax" value={input.OfficeFax || ''} disabled onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="โทรสาร" />
                        </div>
                        <div className="col-6">
                            {/* <TextField id="test" key="test" label="Outlined" variant="outlined" /> */}

                            <CssTextField type="text" name="OfficeHouseNumber" value={input.OfficeHouseNumber || ''} disabled onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ที่อยู่เลขที่" />
                        </div>
                        <div className="col-6">
                            <CssTextField type="text" name="OfficeAddress" value={input.OfficeAddress || ''} disabled onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ถนน" />
                        </div>
                        <div className="col-6">
                            <CssTextField type="text" name="OfficeMoo" value={input.OfficeMoo || ''} disabled onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="หมู่" />
                        </div>
                        <div className="col-6">
                            <CssTextField type="text" name="OfficeAlley" value={input.OfficeAlley || ''} disabled onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ตรอก/ซอย" />
                        </div>

                        <div className="col-12">
                            <CssTextField type="text" name="OfficeSubDistrict" value={input.OfficeSubDistrict || ''} disabled onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ตำบล/แขวง" />


                        </div>
                        <div className="col-12">
                            <CssTextField type="text" name="OfficeDistrict" value={input.OfficeDistrict || ''} disabled onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="อำเภอ/เขต" />


                        </div>

                        <div className="col-12">
                            <CssTextField type="text" name="OfficeProvince" value={input.OfficeProvince || ''} disabled onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="อำเภอ/เขต" />
                        </div>
                        <div className="col-12">

                            <CssTextField type="text" name="OfficeZipcode" value={input.OfficeZipcode || ''} disabled onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="อำเภอ/เขต" />

                        </div>





                        <Typography variant="h6" style={{
                            marginBottom: '15px'
                        }}>
                            เอกสารที่ใช้ในการต่ออายุตัวแทนจำหน่ายเมล็ดพันธุ์
                        </Typography>


                        <div className="col-10">

                            <CssTextField type="text" id="ExpiredAgentExtFiles" name="ExpiredAgentExtFiles" error required className={classes.margin} InputProps={{ disableUnderline: true }} disabled fullWidth id="standard-error-helper-text" label="สำเนาใบอนุญาตตัวแทนจำหน่ายเมล็ดพันธุ์พืช ของกรมการข้าว ที่สิ้นอายุ" />
                            <input type="file"
                                name="ExpiredAgentExtFiles"
                                ref={ExpiredAgentExtFiles}
                                onChange={handleChangeFile}
                                style={{ display: 'none' }}
                            />
                        </div>

                        <div className="col-2 p-0">

                            <Button variant="contained" disabled={input.ExtentionStatus === 'W'} className={classes.buttonUpload} onClick={handleClickUploadExpiredAgentExtFiles}
                            >เลือก</Button>

                        </div>

                        <div className="col-10">

                            <CssTextField type="text" id="IdCardExtFiles" name="IdCardExtFiles" error required className={classes.margin} InputProps={{ disableUnderline: true }} disabled fullWidth id="standard-error-helper-text" label="สำเนาบัตรประจำตัวประชาชน" />
                            <input type="file"
                                name="IdCardExtFiles"
                                ref={IdCardExtFiles}
                                onChange={handleChangeFile}
                                style={{ display: 'none' }}
                            />
                        </div>
                        <div className="col-2 p-0">
                            <Button variant="contained" className={classes.buttonUpload} disabled={input.ExtentionStatus === 'W'} onClick={handleClickUploadIdCardExtFiles}
                            >เลือก</Button>

                        </div>

                        <div className="col-10">
                            <CssTextField type="text" name="JuristicPersonExtFiles" disabled required error className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth id="standard-error-helper-text" label="สำเนาหนังสือจดทะเบียนเป็นนิติบุคคล" />
                            <input type="file"
                                name="JuristicPersonExtFiles"
                                ref={JuristicPersonExtFiles}
                                onChange={handleChangeFile}
                                style={{ display: 'none' }}
                            />
                        </div>
                        <div className="col-2 p-0">
                            <Button variant="contained" className={classes.buttonUpload} disabled={input.ExtentionStatus === 'W'} onClick={handleClickUploadJuristicPersonExtFiles}
                            >เลือก</Button>
                        </div>

                        {/* <div className="col-10">
                            <CssTextField type="text" name="LicenseExtFiles" disabled className={classes.margin} required error InputProps={{ disableUnderline: true }} fullWidth label="ใบอนุญาตขายเมล็ดพันธุ์ควบคุม (พ.พ.4)" />
                            <input type="file"
                                name="LicenseExtFiles"
                                ref={LicenseExtFiles}
                                onChange={handleChangeFile}
                                style={{ display: 'none' }}
                            />
                        </div>
                        <div className="col-2 p-0">
                            <Button variant="contained" className={classes.buttonUpload} onClick={handleClickUploadLicenseExtFiles}
                            >เลือก</Button>
                        </div> */}

                        <div className="col-10">
                            <CssTextField type="text" name="StoreMapExtFiles" disabled className={classes.margin} required error InputProps={{ disableUnderline: true }} fullWidth label="แผนผังที่อยู่แสดงที่อยู่สถานที่ตั้งของสถานที่จำหน่ายเมล็ดพันธ์" />
                            <input type="file"
                                name="StoreMapExtFiles"
                                ref={StoreMapExtFiles}
                                onChange={handleChangeFile}
                                style={{ display: 'none' }}
                            />
                        </div>
                        <div className="col-2 p-0">
                            <Button variant="contained" className={classes.buttonUpload} disabled={input.ExtentionStatus === 'W'} onClick={handleClickUploadStoreMapExtFiles}
                            >เลือก</Button>
                        </div>


                        <div className="col-10">
                            <CssTextField type="text" name="LicenseExtFiles" required error disabled className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="สำเนาใบอนุญาตรวบรวมเมล็ดพันธุ์ควบคุมเพื่อการค้า" />
                            <input type="file"
                                name="LicenseExtFiles"
                                ref={LicenseExtFiles}
                                onChange={handleChangeFile}
                                style={{ display: 'none' }}
                            />
                        </div>
                        <div className="col-2 p-0">
                            <Button variant="contained" disabled={input.ExtentionStatus === 'W'} className={classes.buttonUpload} onClick={handleClickUploadLicenseExtFiles}
                            >เลือก</Button>
                        </div>

                        <div className="col-10">
                            <CssTextField type="text" name="ProxyExtFiles" disabled className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="หนังสือมอบอำนาจ ในกรณีที่ผู้ยื่นคำขอได้รับมอบอำนาจให้ยื่นคำขอต่ออายุแทน" />
                            <input type="file"
                                name="ProxyExtFiles"
                                ref={ProxyExtFiles}
                                onChange={handleChangeFile}
                                style={{ display: 'none' }}
                            />
                        </div>
                        <div className="col-2 p-0">
                            <Button variant="contained" disabled={input.ExtentionStatus === 'W'} className={classes.buttonUpload} onClick={handleClickUploadProxyExtFiles}
                            >เลือก</Button>
                        </div>

                        <Typography variant="h6" style={{
                            marginBottom: '15px'
                        }}>
                            ไฟล์ที่อัพโหลด
                        </Typography>

                        <div className="col-lg-12 col-sm-12 mb-3" >

                            {files.map((file) =>
                                <div className="files-uploaded"  >
                                    <div className="icon-file">
                                        <img src={file.pathImg} alt="file-uploaded" className="file-uploaded" />
                                    </div>
                                    <div className="file-info">
                                        <div className="file-h1">
                                            {file.typeShow}
                                        </div>
                                        <div className="file-d1">
                                            {file.file.name}
                                        </div>
                                    </div>

                                    {input.ExtentionStatus === 'Y' &&
                                        <div className="file-remove">

                                            <HighlightOffIcon style={{
                                                color: 'red',
                                                fontSize: '2rem',
                                                cursor: 'pointer'
                                            }} onClick={() => handleRemove(file)}></HighlightOffIcon>
                                        </div>
                                    }
                                </div>

                            )}

                        </div>


                        <div className="row mt-3 mb-3">
                            {input.ExtentionStatus === 'Y' &&
                                <FormControlLabel
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        // marginTop: '20px'
                                    }}
                                    control={
                                        <Checkbox
                                            name="term"
                                            color="primary"
                                            onChange={handleChange}
                                        />
                                    }
                                    label={<>
                                        <div style={{
                                            fontSize: '0.9rem',
                                            fontWeight: 'bold'
                                        }}>
                                            <span>ข้าพเจ้าขอรับรองว่า ข้อความดังกล่าวข้างต้นเป็นความจริง และจะปฏิบัติตามระเบียบกรมการข้าวว่าด้วยการ เป็นตัวแทนจำหน่ายเมล็ดพันธุ์พืซทุกประการ </span>
                                        </div>

                                    </>}
                                />
                            }
                        </div>

                    </div>





                    {input.ExtentionStatus === 'Y' &&
                        <Button variant="contained" type="submit" className={classes.buttonConfirm} style={{
                            width: '100%',
                            background: '#FBBE66',
                            color: 'white'
                        }}


                        > {isLoadingSubmit ? <div className="spinner-border text-light" role="status">
                            < span className="sr-only"></span>
                        </div> : 'ต่ออายุใบอนุญาตเป็นตัวแทนจำหน่ายเมล็ดพันธุ์พืชของกรมการข้าว'}</Button>
                    }

                    {input.ExtentionStatus === 'W' &&
                        <Button variant="contained" disabled type="submit" className={classes.buttonConfirm} style={{
                            width: '100%',
                            background: 'rgba(0, 0, 0, 0.12)',
                            color: 'white'
                        }}


                        >  กรุณารอเจ้าหน้าที่ตรวจสอบข้อมูล</Button>
                    }
                </form >

            </>
        )
}

const Attachment = (props) => {
    const classes = useStyles();
    const [files, setFiles] = useState([]);
    const [Expirefiles, setExpireFiles] = useState([]);
    const FilesUpload = React.useRef(null);
    const ExpireFilesUpload = React.useRef(null);
    const [messages, setMessages] = useState([]);
    const [isLoadingTab, setLoadingTab] = useState(false);
    const { token, setToken } = useToken();
    const [url, setUrl] = useState('');
    let [isLoadingSubmit, setLoadingSubmit] = useState(false);

    const [fileRemove, setFilesRemove] = useState([]);
    let [input, setInput] = useState({
        RequestNo: '',
        AgentNumber: '',
        typeFileSelected: TypesFile[0].value,
        ExpiretypeFileSelected: TypesFileExpires[0].value,
    });
    const init = async () => {
        const response = await fetch("/resources/config.json");
        const results = await response.json();
        setUrl(results?.REACT_APP_ADMIN_URL);
    }
    useEffect(() => {

        // const fetchPost = async () => {
        //     const response = await fetch('`${process.env.REACT_APP_BASE_URL}/dbms/branchs');

        //     const b = await response.json();
        //     setBranchs(b.result)
        // }




        // fetchPost();
        init()
        getProfile();

    }, []);

    const handleClickUpload = event => {

        FilesUpload.current.click();
    };

    const handleClickUploadExpire = event => {

        ExpireFilesUpload.current.click();
    };

    const handleChange = e => {

        const { target } = e;
        const { name } = target;


        const value = name === 'term' ? target.checked : target.value;
        setInput({
            ...input,
            [name]: value
        });
    }
    const getProfile = async () => {
        setLoadingTab(true);

        const res = await api.get(`/profile/agents/${localStorage.getItem('requestNo')}`, { headers: { "Authorization": `Bearer ${token}` } });
        const profile = res.data.result;
        if (profile) {
            setInput({
                ...input,
                ...profile
            });

            const _FilesAgent = res.data.result.Files;
            const _ExpireFilesAgent = res.data.result.ExtentionFiles;
            let fixfileUploaded = [];
            let fixfileExpireUploaded = [];
            for (const c of _FilesAgent) {

                const type = TypesFile.find(x => x.value === c.FileType);

                const extension = c.FileName.split('.')?.pop();
                const pathImg = getPathImage(extension);
                fixfileUploaded.push({
                    UploadFileId: c.UploadFileId,
                    file: {
                        name: c.FileName
                    },
                    typeName: c.FileType,
                    typeShow: type.name,
                    typeFile: extension,
                    pathImg: pathImg,
                    isNew: false
                })

                setFiles(fixfileUploaded);
            }

            for (const c of _ExpireFilesAgent) {

                const type = TypesFileExpires.find(x => x.value === c.FileType);

                const extension = c.FileName.split('.')?.pop();
                const pathImg = getPathImage(extension);
                fixfileExpireUploaded.push({
                    UploadFileId: c.UploadFileId,
                    file: {
                        name: c.FileName
                    },
                    typeName: c.FileType,
                    typeShow: type.name,
                    typeFile: extension,
                    pathImg: pathImg,
                    isNew: false
                })

                setExpireFiles(fixfileExpireUploaded);
            }



            if (profile.RequestDocs.length > 0) {
                const _message = profile.RequestDocs;
                _message.forEach(x => {
                    x.CreateDate = convertISOStringToMonthDay(x.CreateDate);
                })
                setMessages(_message);
            }


        }


        setLoadingTab(false);
        // return () => clearInterval(interval);

    }

    const removeFiles = async (body) => {

        const data = {
            FileIDs: body
        }
        const path = `/remove-files`

        const res = await api.put(path, data, { headers: { "Authorization": `Bearer ${token}` } });
    }

    const handleChangeFile = (event) => {

        const { target } = event;
        const { name } = target;
        const value = target.value;
        if (event.target.files.length > 0) {
            const fileUploaded = event.target.files[0];
            const type = TypesFile.find(x => x.value === input.typeFileSelected);
            const extension = fileUploaded.name.split('.')?.pop();
            const pathImg = getPathImage(extension);

            const fixfileUploaded = {
                UploadFileId: null,
                file: fileUploaded,
                typeName: type.value,
                typeShow: type.name,
                typeFile: extension,
                pathImg: pathImg,
                isNew: true
            }
            const updateFiles = [
                ...files,
                fixfileUploaded,
            ];
            // update the state to the updatedUsers
            setFiles(updateFiles);
        }

    };

    const handleChangeFileExpire = (event) => {

        const { target } = event;
        const { name } = target;
        const value = target.value;
        if (event.target.files.length > 0) {
            const fileUploaded = event.target.files[0];
            const type = TypesFileExpires.find(x => x.value === input.ExpiretypeFileSelected);
            const extension = fileUploaded.name.split('.')?.pop();
            const pathImg = getPathImage(extension);

            const fixfileUploaded = {
                UploadFileId: null,
                file: fileUploaded,
                typeName: type.value,
                typeShow: type.name,
                typeFile: extension,
                pathImg: pathImg,
                isNew: true
            }
            const updateFiles = [
                ...Expirefiles,
                fixfileUploaded,
            ];
            // update the state to the updatedUsers
            setExpireFiles(updateFiles);
        }

    };



    const getPathImage = (extension) => {
        if (extension === 'png') {
            return 'icons/png.svg';
        }
        else if (extension === 'jpg') {
            return 'icons/jpg.svg';
        }
        else if (extension === 'pdf') {
            return 'icons/pdf.svg';
        }
        else if (extension === 'doc') {
            return 'icons/doc.svg';
        }
        else if (extension === 'txt') {
            return 'icons/txt.svg';
        }
        else if (extension === 'zip') {
            return 'icons/zip.svg';
        }
        else if (extension === 'xls' || extension === 'xlsx') {
            return 'icons/xls.svg';
        }
        else {
            return 'icons/file.svg';
        }

    }

    const handleRemove = (file) => {

        if (file.UploadFileId) {
            let _fileRemoves = fileRemove;
            _fileRemoves.push(file.UploadFileId);
            setFilesRemove(_fileRemoves)
        }

        const newFiles = files.filter((files) => files !== file);

        setFiles(newFiles);

    };

    const handleRemoveExpire = (file) => {

        if (file.UploadFileId) {
            let _fileRemoves = fileRemove;
            _fileRemoves.push(file.UploadFileId);
            setFilesRemove(_fileRemoves)
        }

        const newFiles = Expirefiles.filter((files) => files !== file);

        setExpireFiles(newFiles);

    };



    const onSubmit = async e => {

        e.preventDefault()
        setLoadingSubmit(true);
        const body = input;
        const addFiles = files.length > 0 ? files.filter(x => x.isNew) : [];

        const _fileRemove = fileRemove.length > 0 ? fileRemove : [];
        if (_fileRemove.length > 0) {
            await removeFiles(_fileRemove);
        }

        if (body.ExtentionStatus === 'W') {
            const formDataExpire = new FormData();
            const addExpireFiles = Expirefiles.length > 0 ? Expirefiles.filter(x => x.isNew) : [];
            if (addExpireFiles.length > 0) {
                for (const c of addExpireFiles) {

                    formDataExpire.append(c.typeName, c.file);
                }
            }

            const res = await api.post(`/profile/agents/${localStorage.getItem('requestNo')}/extention`, formDataExpire, { headers: { "Authorization": `Bearer ${token}` } });
        }

        const formData = new FormData();

        if (addFiles.length > 0) {
            for (const c of addFiles) {
                formData.append(c.typeName, c.file);
            }
        }
        formData.append('AgentNumber', input.AgentNumber);
        formData.append('RequestNo', input.RequestNo);
        const res = await api.put(`/profile/agents/${localStorage.getItem('requestNo')}`, formData, { headers: { "Authorization": `Bearer ${token}` } });

        if (res.data.status) {


            props.props.snackbarShowMessage(`บันทึกข้อมูลสำเร็จ`);
            getProfile();
            setLoadingSubmit(false);
        } else {
            props.props.snackbarShowMessage(`มีบางอย่างผิดพลาดกรุณาลองใหม่อีกครั้ง`, 'error');
            setLoadingSubmit(false);
        }

    }
    console.log(messages);

    if (isLoadingTab)
        return (
            <>
                <CircularProgress size={100} />
            </>
        )

    else

        return (
            <>



                <Typography variant="h6" style={{
                    marginBottom: '15px'
                }}>
                    ข้อความจากเจ้าหน้าที่
                </Typography>
                <div className="row" style={{
                    height: '30vh',
                    overflow: 'auto'
                }}>
                    {messages.map((m) => {
                        return (
                            <>
                                <div className="row d-flex mt-3" >

                                    <div className="col-md-1 col-sm-3">
                                        <div className="text-center pt-3 pb-3">
                                            <img style={{
                                                width: '30px',
                                                height: '30px',

                                            }} src='user.png' alt="confirmemail"></img>
                                        </div>
                                    </div>
                                    <div className="col-md-10 col-sm-9">


                                        <div style={{
                                            background: '#E6EBF1',
                                            padding: '15px',
                                            fontSize: '13px',
                                            borderRadius: '12px',
                                            boxShadow: '0px 3px 17px #00000029',
                                            display: 'inline-block'
                                        }}>
                                            {m.IdCard &&
                                                <><Typography style={{ fontWeight: "600" }}>สำเนาบัตรประจำตัวประชาชน</Typography>
                                                    <p style={{ marginBottom: '10px' }}>-{m.IdCardRemark}</p></>}
                                            {m.JuristicPerson &&
                                                <><Typography style={{ fontWeight: "600" }}>สำเนาหนังสือจดทะเบียนนิติบุคคล</Typography>
                                                    <p style={{ marginBottom: '10px' }}>-{m.JuristicPersonRemark}</p></>}
                                            {m.License &&
                                                <><Typography style={{ fontWeight: "600" }}>สำเนาใบอนุญาตขายเมล็ดพันธุ์ควบคุม (พ.พ.4)</Typography>
                                                    <p style={{ marginBottom: '10px' }}>-{m.LicenseRemark}</p></>}
                                            {m.StoreMap &&
                                                <><Typography style={{ fontWeight: "600" }}>แผนผังแสดงที่อยู่สถานที่ตั้งของสถานที่จำหน่ายเมล็ดพันธุ์</Typography>
                                                    <p style={{ marginBottom: '10px' }}>-{m.StoreMapRemark}</p></>}
                                            {m.Proxy &&
                                                <><Typography style={{ fontWeight: "600" }}>หนังสือมอบอำนาจซึ่งติดอากรแสตมป์ตามกฎหมาย</Typography>
                                                    <p style={{ marginBottom: '10px' }}>-{m.ProxyRemark}</p></>}
                                            {m.Other &&
                                                <><Typography style={{ fontWeight: "600" }}>เอกสารอื่นๆ</Typography>
                                                    <p style={{ marginBottom: '10px' }}>-{m.OtherRemark}</p></>}
                                            {m.Remark &&
                                                <><Typography style={{ fontWeight: "600" }}>หมายเหตุ</Typography>
                                                    <p>-{m.Remark}</p></>}
                                        </div>
                                        <div style={{
                                            fontSize: '10px',
                                            color: '#838EAB',
                                            marginTop: '5px',
                                            marginLeft: '5px'
                                        }}>


                                            {m.CreateDate}

                                        </div>
                                    </div>
                                </div>
                            </>
                        )
                    }

                    )}
                </div>


                <hr style={{
                    color: 'gray'
                }}>




                </hr>
                <Typography variant="h6" style={{
                    marginBottom: '15px'
                }}>
                    เอกสารที่ต้องการอัพโหลด
                </Typography>
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-10">

                            <CssTextField select className={classes.margin} name="typeFileSelected" value={input.typeFileSelected} required error={true} onClick={handleChange} InputProps={{ disableUnderline: true }} fullWidth label="เลือกเอกสารที่ต้องการอัพโหลด">


                                {TypesFile.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.name}
                                    </MenuItem>
                                ))}


                            </CssTextField>

                            <input type="file"
                                name="FilesUpload"
                                ref={FilesUpload}
                                onChange={handleChangeFile}
                                style={{ display: 'none' }}

                            />

                        </div>
                        <div className="col-2 p-0">
                            <Button variant="contained" className={classes.buttonUpload} onClick={handleClickUpload}
                            >เลือกไฟล์</Button>

                        </div>

                        <Typography variant="h6" style={{
                            marginBottom: '15px'
                        }}>
                            ไฟล์ที่อัพโหลด
                        </Typography>


                        <div className="col-lg-12 col-sm-12" >

                            {files.map((file) =>
                                <div className="files-uploaded"  >
                                    <div className="icon-file">
                                        <img src={file.pathImg} alt="file-uploaded" className="file-uploaded" />
                                    </div>
                                    <div className="file-info">
                                        <div className="file-h1">
                                            {file.typeShow}
                                        </div>
                                        <div className="file-d1">
                                            {file.file.name}
                                        </div>
                                    </div>
                                    <div className="file-remove">

                                        <HighlightOffIcon style={{
                                            color: 'red',
                                            fontSize: '2rem',
                                            cursor: 'pointer'
                                        }} onClick={() => handleRemove(file)}></HighlightOffIcon>
                                    </div>
                                </div>
                            )}

                        </div>

                    </div>
                    {input.ExtentionStatus === 'W' &&
                        <div className="row">
                            <Typography variant="h6" style={{
                                marginBottom: '15px',
                                color: 'red',
                                marginTop: '30px'
                            }}>
                                ไฟล์ที่อัพโหลด ( สำหรับการต่ออายุตัวแทน )
                            </Typography>
                            <div className="col-10">

                                <CssTextField select className={classes.margin} name="ExpiretypeFileSelected" value={input.ExpiretypeFileSelected} required error={true} onClick={handleChange} InputProps={{ disableUnderline: true }} fullWidth label="เลือกเอกสารที่ต้องการอัพโหลด">


                                    {TypesFileExpires.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.name}
                                        </MenuItem>
                                    ))}


                                </CssTextField>

                                <input type="file"
                                    name="FilesUpload"
                                    ref={ExpireFilesUpload}
                                    onChange={handleChangeFileExpire}
                                    style={{ display: 'none' }}

                                />

                            </div>
                            <div className="col-2 p-0">
                                <Button variant="contained" className={classes.buttonUpload} onClick={handleClickUploadExpire}
                                >เลือก</Button>

                            </div>

                            <div className="col-lg-12 col-sm-12" >

                                {Expirefiles.map((file) =>
                                    <div className="files-uploaded"  >
                                        <div className="icon-file">
                                            <img src={file.pathImg} alt="file-uploaded" className="file-uploaded" />
                                        </div>
                                        <div className="file-info">
                                            <div className="file-h1">
                                                {file.typeShow}
                                            </div>
                                            <div className="file-d1">
                                                {file.file.name}
                                            </div>
                                        </div>
                                        <div className="file-remove">

                                            <HighlightOffIcon style={{
                                                color: 'red',
                                                fontSize: '2rem',
                                                cursor: 'pointer'
                                            }} onClick={() => handleRemoveExpire(file)}></HighlightOffIcon>
                                        </div>
                                    </div>
                                )}

                            </div>
                        </div>
                    }
                    <Button variant="contained" type="submit" style={{
                        marginTop: '20px'
                    }} className={classes.buttonConfirm} color="primary"
                    >{isLoadingSubmit ? <div className="spinner-border text-light" role="status">
                        <span className="sr-only"></span>
                    </div> : 'บันทึก'}</Button>
                </form>


            </>
        )
}

function ChangePassword(props) {
    const classes = useStyles();
    const { token, setToken } = useToken();
    let [isLoadingSubmit, setLoadingSubmit] = useState(false);
    let [input, setInput] = useState({
        password: '',
        confirmPassword: '',

    });

    const [values, setValues] = React.useState({
        showPassword: false,
        showConfirmPassword: false
    });
    useEffect(() => {
        // getProfile();

    }, []);

    // const getProfile = async () => {

    //     const res = await axios.get('`${process.env.REACT_APP_BASE_URL}/profile/agent', { headers: { "Authorization": `Bearer ${token}` } });
    //     const profile = res.data.result;
    //     if (profile) {
    //         setInput({
    //             ...input,
    //             ...profile
    //         });
    //     }

    // }
    const handleChange = e => {

        const { target } = e;
        const { name } = target;


        const value = name === 'showPassword' || name === 'showConfirmPassword' ? target.checked : target.value;
        setInput({
            ...input,
            [name]: value
        });
    }

    const handleClickShowPassword = () => {
        setValues({
            ...values,

            showPassword: !values.showPassword,
        });
    };

    const handleClickShowConfirmPassword = () => {
        setValues({
            ...values,
            showConfirmPassword: !values.showConfirmPassword
        });
    };

    const onSubmit = async e => {

        e.preventDefault()

        if (input.password !== input.confirmPassword) {
            props.props.snackbarShowMessage(`ยืนยันรหัสผ่านไม่ถูกต้อง`, 'error');
            return;
        }

        setLoadingSubmit(true);
        const body = {
            Password: input.password
        };
        const res = await api.put(`/profile/user`, body, { headers: { "Authorization": `Bearer ${token}` } });

        if (res.data.status) {


            props.props.snackbarShowMessage(`เปลี่ยนรหัสผ่านสำเร็จ`);
            setInput({
                password: '',
                confirmPassword: ''
            });
            setLoadingSubmit(false);
        } else {
            props.props.snackbarShowMessage(`มีบางอย่างผิดพลาดกรุณาลองใหม่อีกครั้ง`, 'error');
            setLoadingSubmit(false);
        }

    }

    return (
        <>
            <form onSubmit={onSubmit}>
                <div className="col-6 pb-3">
                    {/* <CssTextField type="password" required error={true} name="password" id="password" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="รหัสผ่านใหม่" /> */}
                    <Paper className={classes.customInput}>

                        <InputBase onChange={handleChange} required error={true}
                            className={classes.input}
                            placeholder="รหัสผ่านใหม่"
                            label="password"
                            type={values.showPassword ? 'text' : 'password'}
                            id="password"
                            name="password"
                        />
                        <IconButton className={classes.iconButton} aria-label="menu"
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                        >
                            {values.showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                    </Paper>
                </div>
                <div className="col-6 pb-3">
                    {/* <CssTextField type="password" required error={true} name="confirmPassword" id="confirmPassword" onChange={handleChange} className={classes.margin} InputProps={{ disableUnderline: true }} fullWidth label="ยืนยันรหัสผ่านใหม่" /> */}
                    <Paper className={classes.customInput}>

                        <InputBase onChange={handleChange} required error={true}
                            className={classes.input}
                            placeholder="ยืนยันรหัสผ่านใหม่"
                            label="password"
                            type={values.showConfirmPassword ? 'text' : 'password'}
                            name="confirmPassword" id="confirmPassword"
                        />
                        <IconButton className={classes.iconButton} aria-label="menu"
                            aria-label="toggle password visibility"
                            onClick={handleClickShowConfirmPassword}
                        >
                            {values.showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                    </Paper>
                </div>

                <Button variant="contained" type="submit" className={classes.buttonConfirm} color="primary"
                >{isLoadingSubmit ? <div className="spinner-border text-light" role="status">
                    <span className="sr-only"></span>
                </div> : 'บันทึก'}</Button>
            </form>
        </>
    )

}



const History = (props) => {
    const classes = useStyles();
    let [history, setHistory] = useState([]);
    const [isLoadingSubmit, setLoadingSubmit] = useState(false);
    const [agent, setAgent] = useState();
    const [isLoadingTab, setLoadingTab] = useState(false);
    const { token, setToken } = useToken();

    const getProfile = async () => {
        setLoadingTab(true);

        const res = await api.get(`/profile/agents/${localStorage.getItem('requestNo')}`, { headers: { "Authorization": `Bearer ${token}` } });
        const profile = res.data.result;
        if (profile) {
            setAgent(profile)

        }


        setLoadingTab(false);
        // return () => clearInterval(interval);

    }
    useEffect(() => {
        getProfile()
        LoadHistory();
    }, []);

    const downloadFile = async (_history, index) => {
        history[index].loading = true;
        const setLoadingtrue = [
            ...history
        ]
        setHistory(setLoadingtrue);
        const path = `/profile/agents/${localStorage.getItem('requestNo')}/register/pdf`;

        const res = await api.get(path, {
            params: { version: _history.Version },
            responseType: 'arraybuffer',
            headers: { "Authorization": `Bearer ${token}` }
        });
        const buffer = res.data;
        const blob = new Blob([buffer], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        history[index].loading = false;
        const setLoadingFalse = [
            ...history
        ]
        setHistory(setLoadingFalse);
        window.open(url, '_blank');
    }

    const LoadHistory = async () => {
        setLoadingTab(true);

        const res = await api.get(`/profile/agents/${localStorage.getItem('requestNo')}/histories`, { headers: { "Authorization": `Bearer ${token}` } });
        const result = res.data.result;

        if (result.length > 0) {

            const _history = result;
            _history.forEach(x => {
                if (x.ActionDate) {
                    x.ActionDate = convertISOStringToMonthDay(x.ActionDate);
                    x.loading = false;
                }

            })
            setHistory(_history);


        }

        setLoadingTab(false);
        // return () => clearInterval(interval);

    }

    if (isLoadingTab)
        return (
            <>
                <CircularProgress size={100} />
            </>
        )
    else
        return (
            <>
                <div className="row">
                    <div className="col-12" style={{
                        maxHeight: 'calc(100vh - 16rem)',
                        overflow: 'auto'
                    }}>
                        <table className="table table-bordered  table-responsive-sm">
                            <thead style={{
                                fontSize: '15px',
                                position: 'sticky',

                                top: 0,
                                zIndex: 10
                            }}>

                                <tr style={{
                                    background: '#4472c4',
                                    color: 'white'
                                }}>
                                    <th scope="col" ></th>
                                    <th scope="col" >วันที่</th>
                                    <th scope="col" >รายการ</th>
                                    <th scope="col" >สถานะ</th>
                                </tr>
                            </thead>
                            <tbody style={{
                                fontSize: '14px',
                                verticalAlign: 'middle',
                            }}>
                                {history.map((v, index) => {
                                    return (
                                        <tr key={index} style={{
                                            // background: index % 2 === 0 ? 'rgb(233, 235, 245)' : 'rgb(207, 213, 234)'
                                        }}>
                                            <td>{index + 1}</td>
                                            <td>{v.ActionDate}</td>
                                            <td>{v.Action}</td>
                                            <td>
                                                {/* {v.AgentNumber &&
                                                    <Button variant="contained" onClick={() => downloadFile(v, index)} disabled={v.loading} className={classes.buttonConfirm} color="primary" style={{
                                                        fontSize: '14px'
                                                    }}
                                                    >{v.loading ? <div className="spinner-border " role="status">
                                                        <span className="sr-only"></span>
                                                    </div> : <GetAppIcon style={{
                                                        marginRight: '5px'
                                                    }}></GetAppIcon>} {v.loading ? '' : 'Download'} </Button>
                                                } */}
                                                {v.Status}
                                            </td>
                                        </tr>
                                    );


                                })}
                            </tbody>
                        </table>
                        {  agent?.Status === 'Y' ?
                        agent?.ApproverName &&  <Typography variant='h6'>กรุณาติดต่อ  {agent?.ApproverName || '-'} โทร. {agent?.ApproverTel || '-'} เพื่อขอรับใบอนุญาต</Typography> : 
                        agent?.ApproverName && <Typography variant='h6'>กรุณาติดต่อ {agent?.ApproverName}  โทร. {agent?.ApproverTel} เพื่อสอบถามข้อมูลเพิ่มเติม</Typography>}
                    </div>

                </div>
            </>
        )
}




export default withSnackbar(Profile)
